{
  "Les langues de la maison et du public sont distinctes.": {
    "de": "Die Sprache des Veranstaltungsorts und die Sprache der Gäste sind getrennt.",
    "en": "The venue language and visitor language are separate."
  },
  "La boutique et le portail proposent le français, l’allemand et l’anglais. Les billets, factures et courriels suivent la langue par défaut de la maison. Les textes saisis par la salle restent tels quels. Le back-office et l’aide restent principalement en français. L’italien n’est pas proposé.": {
    "de": "Shop und Portal sind auf Französisch, Deutsch und Englisch verfügbar. Tickets, Rechnungen und E-Mails verwenden die Standardsprache des Veranstaltungsorts. Vom Veranstaltungsort eingegebene Texte bleiben unverändert. Backoffice und Hilfe sind überwiegend auf Französisch. Italienisch wird nicht angeboten.",
    "en": "The shop and portal are available in French, German and English. Tickets, invoices and emails use the venue’s default language. Text entered by the venue is kept as written. The back office and help remain mainly in French. Italian is not offered."
  },
  "Simulez le coût annuel de votre billetterie": {
    "de": "Simulieren Sie die Jahreskosten Ihres Ticketings",
    "en": "Estimate your annual ticketing cost"
  },
  "Indiquez vos ventes et le coût de votre propre prestataire de paiement. Le calcul reste dans votre navigateur.": {
    "de": "Geben Sie Ihre Verkäufe und die Kosten Ihres Zahlungsanbieters ein. Die Berechnung bleibt in Ihrem Browser.",
    "en": "Enter your sales and the cost of your own payment provider. The calculation stays in your browser."
  },
  "Billets vendus par an": {
    "de": "Verkaufte Tickets pro Jahr",
    "en": "Tickets sold per year"
  },
  "Ventes en ligne": {
    "de": "Onlineverkäufe",
    "en": "Online sales"
  },
  "Prix moyen du billet": {
    "de": "Durchschnittlicher Ticketpreis",
    "en": "Average ticket price"
  },
  "billets en ligne": {
    "de": "Tickets online",
    "en": "online tickets"
  },
  "billets par facture QR ou au guichet": {
    "de": "Tickets per QR-Rechnung oder an der Kasse",
    "en": "tickets by QR bill or at the box office"
  },
  "Frais du prestataire sur les ventes en ligne (%)": {
    "de": "Gebühren des Zahlungsanbieters für Onlineverkäufe (%)",
    "en": "Provider fee on online sales (%)"
  },
  "Frais fixes par billet en ligne (CHF)": {
    "de": "Fixgebühr pro Online-Ticket (CHF)",
    "en": "Fixed fee per online ticket (CHF)"
  },
  "Logiciel ILYGO par an": {
    "de": "ILYGO-Software pro Jahr",
    "en": "ILYGO software per year"
  },
  "Coût du prestataire estimé": {
    "de": "Geschätzte Kosten des Zahlungsanbieters",
    "en": "Estimated provider cost"
  },
  "Total annuel estimé": {
    "de": "Geschätzte Jahreskosten",
    "en": "Estimated annual total"
  },
  "par billet, dont": {
    "de": "pro Ticket, davon",
    "en": "per ticket, including"
  },
  "pour le logiciel": {
    "de": "für die Software",
    "en": "for the software"
  },
  "Hypothèse : un paiement par billet vendu en ligne, arrondi au centime. Les ventes par facture QR ou au guichet sont supposées sans frais de paiement. Les frais de votre prestataire sont estimés pour comparer le coût total ; ILYGO ne les facture pas.": {
    "de": "Annahme: eine Zahlung pro online verkauftem Ticket, auf Rappen gerundet. Für Verkäufe per QR-Rechnung oder an der Kasse werden keine Zahlungsgebühren angenommen. Die Gebühren Ihres Anbieters dienen der Schätzung der Gesamtkosten; ILYGO stellt sie nicht in Rechnung.",
    "en": "Assumption: one payment per ticket sold online, rounded to the nearest centime. QR-bill and box-office sales are assumed to have no payment fees. Your provider’s fees are estimated to show the total cost; ILYGO does not charge them."
  },
  "À titre indicatif, la part logicielle seule se situe entre CHF 0.22 et CHF 1.02 par billet dans les références étudiées. Le repère ci-dessous montre uniquement le coût du logiciel ILYGO, sans les frais de paiement simulés.": {
    "de": "Zur Orientierung: Bei den untersuchten Anbietern liegt der reine Softwareanteil zwischen CHF 0.22 und CHF 1.02 pro Ticket. Die Markierung unten zeigt nur die Kosten der ILYGO-Software, ohne die geschätzten Zahlungsgebühren.",
    "en": "For reference, the software portion alone ranges from CHF 0.22 to CHF 1.02 per ticket among the providers studied. The marker below shows only the ILYGO software cost, excluding estimated payment fees."
  },
  "Position du coût logiciel ILYGO dans la fourchette indicative": {
    "de": "Position der ILYGO-Softwarekosten in der Vergleichsspanne",
    "en": "ILYGO software cost within the indicative range"
  },
  "Agrandir": {
    "de": "Vergrössern",
    "en": "Enlarge"
  },
  "Fermer": {
    "de": "Schliessen",
    "en": "Close"
  },
  "Saison 2027-2028 ·": {
    "de": "Spielzeit 2027–2028 ·",
    "en": "2027–2028 season ·"
  },
  "Exemple de carte d’abonné": {
    "de": "Beispiel einer Abonnentenkarte",
    "en": "Example subscriber card"
  },
  "Plan de salle stylisé de neuf rangs. Les sièges y apparaissent libres, vendus, pris par abonnement, offerts en invitation, gelés par la campagne de réabonnement, hors vente, ou en cours de sélection au guichet.": {
    "de": "Schematischer Saalplan mit neun Reihen: freie, verkaufte und abonnierte Plätze, Einladungen, für die Kampagne gesperrte und nicht verkäufliche Plätze sowie die aktuelle Kassenauswahl.",
    "en": "Stylised nine-row seating plan: available, sold and subscriber seats, invitations, campaign holds, unavailable seats and the current box-office selection."
  },
  ", voir en grand": {
    "de": ", Grossansicht öffnen",
    "en": ", view full size"
  },
  "Vue agrandie": {
    "de": "Grossansicht",
    "en": "Enlarged view"
  },
  "Théâtres et salles à programmation": {
    "de": "Theater und Häuser mit Spielplan",
    "en": "Theatres and programmed venues"
  },
  "Événements ponctuels": {
    "de": "Einzelveranstaltungen",
    "en": "One-off events"
  },
  "Créer ma billetterie": {
    "de": "Mein Ticketing einrichten",
    "en": "Create my ticketing site"
  },
  "La chaîne entière, dans l’ordre où votre année la traverse. Rien de ce qui suit n’est un module en supplément : tout est compris dans le forfait.": {
    "de": "Die ganze Kette in der Reihenfolge Ihres Jahres. Nichts davon ist ein Zusatzmodul: Alles ist in der Pauschale enthalten.",
    "en": "The entire chain, in the order your year follows. None of this is an extra module: everything is included in the flat fee."
  },
  "Au printemps, une salle rejoue la même séquence : qui reprend, qui change de jour, qui abandonne, et surtout qui garde sa place. Ce moment se tient aujourd’hui au téléphone, sur un tableur et dans un classeur. Ici, c’est une séquence outillée, avec ses états, ses garde-fous et son écran de suivi.": {
    "de": "Jeden Frühling dieselben Fragen: Wer verlängert, wechselt den Tag, verzichtet oder behält seinen Platz? Bisher geschieht das per Telefon, Tabelle und Ordner. Hier wird daraus ein unterstützter Ablauf mit Zuständen, Schutzregeln und Übersicht.",
    "en": "Each spring brings the same questions: who renews, changes day, leaves, and above all keeps their seat? Today this happens by phone, spreadsheet and binder. Here it is a supported workflow with states, safeguards and a progress screen."
  },
  "Sept faits, aucun adjectif. Chacun se vérifie écran en main, en trente secondes, pendant une démonstration. C’est bien pour cela qu’ils sont écrits en chiffres plutôt qu’en promesses.": {
    "de": "Sieben Fakten, keine Adjektive. Jeder lässt sich während einer Vorführung in dreissig Sekunden am Bildschirm prüfen. Deshalb stehen hier Zahlen statt Versprechen.",
    "en": "Seven facts, no adjectives. Each can be checked on screen in thirty seconds during a demo. That is why they are written as numbers, not promises."
  },
  "Encaisser": {
    "de": "Kassieren",
    "en": "Take payment"
  },
  "Le même plan de salle, les mêmes tarifs, la même règle « un siège, un billet ». Ce que vend la boutique et ce que vend votre guichet ne peuvent pas se contredire : c’est la base de données qui arbitre, pas un rapprochement de fin de soirée.": {
    "de": "Derselbe Saalplan, dieselben Preise und dieselbe Regel: ein Platz, ein Ticket. Shop und Kasse können nicht gegeneinander verkaufen: Die Datenbank entscheidet, nicht ein Abgleich am Abend.",
    "en": "The same seating plan, prices and one-seat-one-ticket rule. Shop and box-office sales cannot conflict: the database decides, not an end-of-night reconciliation."
  },
  "SCÈNE": {
    "de": "BÜHNE",
    "en": "STAGE"
  },
  "Entrée": {
    "de": "Eintritt",
    "en": "Admission"
  },
  "Libre": {
    "de": "Frei",
    "en": "Available"
  },
  "Vendu": {
    "de": "Verkauft",
    "en": "Sold"
  },
  "Abonnement": {
    "de": "Abonnement",
    "en": "Subscription"
  },
  "Invitation": {
    "de": "Einladung",
    "en": "Invitation"
  },
  "Gelé par la campagne": {
    "de": "Für die Kampagne gesperrt",
    "en": "Held for the campaign"
  },
  "Hors vente": {
    "de": "Nicht verkäuflich",
    "en": "Not for sale"
  },
  "Sélection en cours": {
    "de": "Aktuelle Auswahl",
    "en": "Current selection"
  },
  "Carnet": {
    "de": "Eintrittsguthaben",
    "en": "Admission book"
  },
  "Un billet, une facture, une carte. Trois documents que votre public tient dans la main. Le billet et la facture montrés ici sont sortis de l’application ; la carte en donne un fac-similé fidèle.": {
    "de": "Ein Ticket, eine Rechnung, eine Karte: drei Dokumente für Ihr Publikum. Das gezeigte Ticket und die Rechnung stammen aus der Anwendung; die Karte ist eine originalgetreue Nachbildung.",
    "en": "A ticket, an invoice, a card: three documents for your audience. The ticket and invoice shown here came from the application; the card is a faithful illustration."
  },
  "Carte d’abonné": {
    "de": "Abonnentenkarte",
    "en": "Subscriber card"
  },
  "Saison 2027-2028 · Théâtre du Bourg-Neuf": {
    "de": "Spielzeit 2027–2028 · Théâtre du Bourg-Neuf",
    "en": "2027–2028 season · Théâtre du Bourg-Neuf"
  },
  "Titulaire": {
    "de": "Karteninhaberin",
    "en": "Cardholder"
  },
  "Formule": {
    "de": "Abonnementart",
    "en": "Pass type"
  },
  "Série Mardi · 8 spectacles": {
    "de": "Dienstagsserie · 8 Veranstaltungen",
    "en": "Tuesday Series · 8 shows"
  },
  "Place": {
    "de": "Platz",
    "en": "Seat"
  },
  "F12 · une entrée par représentation": {
    "de": "F12 · ein Eintritt pro Vorstellung",
    "en": "F12 · one admission per performance"
  },
  "jeton aléatoire · aucune donnée dans le QR": {
    "de": "Zufallstoken · keine Daten im QR",
    "en": "random token · no data in the QR"
  },
  "Admis": {
    "de": "Eingelassen",
    "en": "Admitted"
  },
  "Elles ne se mesurent pas en pourcentages : elles se vérifient un soir de première, écran en main, quand quelque chose ne se passe pas comme prévu.": {
    "de": "Nicht in Prozent gemessen, sondern am Premierenabend am Bildschirm geprüft, wenn etwas anders läuft als geplant.",
    "en": "Not measured in percentages: checked on opening night, on screen, when something does not go as planned."
  },
  "Une date, un lieu": {
    "de": "Ein Termin, ein Ort",
    "en": "One date, one venue"
  },
  "Un concert, une fête d’entreprise, une soirée en plein air. Pas de saison, pas d’abonnement : des entrées à vendre et une liste à contrôler à la porte.": {
    "de": "Ein Konzert, ein Firmenfest, ein Abend im Freien. Keine Saison, kein Abonnement: Eintritte verkaufen und am Eingang kontrollieren.",
    "en": "A concert, a company party, an outdoor evening. No season, no subscription: admissions to sell and a list to check at the door."
  },
  "Un lieu décrit par sa jauge plutôt que par un plan : on y choisit une quantité de places, pas un fauteuil.": {
    "de": "Ein Ort mit Kapazität statt Saalplan: Sie wählen eine Anzahl, keinen Sitz.",
    "en": "A venue defined by capacity rather than a plan: choose a quantity, not a seat."
  },
  "Le même parcours d’achat public, la même facture QR, le même contrôle d’accès au téléphone.": {
    "de": "Derselbe Kaufablauf, dieselbe QR-Rechnung, dieselbe Einlasskontrolle am Telefon.",
    "en": "The same public checkout, QR-bill and phone-based admission checks."
  },
  "Une interface allégée : ni campagne, ni formules, ni réabonnement à traverser.": {
    "de": "Eine schlanke Oberfläche ohne Kampagne, Abonnements oder Verlängerung.",
    "en": "A streamlined interface, without campaigns, passes or renewals to navigate."
  },
  "Le montant se calcule sur le nombre total de vos sièges, toutes vos salles additionnées, un point c’est tout. Il ne bouge pas si la saison est mauvaise, et il ne prélève rien sur ce que vous vendez.": {
    "de": "Der Betrag richtet sich ausschliesslich nach allen Sitzplätzen Ihrer Säle zusammen. Er bleibt auch bei einer schlechten Saison gleich und nimmt keinen Anteil an Ihren Verkäufen.",
    "en": "The amount depends only on the total seats across all your rooms. It stays the same in a poor season and takes no share of your sales."
  },
  "Un logiciel qui promet tout se paie au moment de l’installation. Voici la ligne exacte. Nous préférons que vous la lisiez ici plutôt que de la découvrir en démonstration. Et tout ce qui est écrit au-dessus de cette section, nous vous le montrons écran en main.": {
    "de": "Software, die alles verspricht, wird bei der Installation teuer. Hier sind die genauen Grenzen, bevor Sie sie in einer Vorführung entdecken. Alles, was weiter oben steht, zeigen wir Ihnen am Bildschirm.",
    "en": "Software promising everything makes you pay at installation. These are the exact limits, stated here rather than left for a demo. Everything above this section can be demonstrated on screen."
  },
  "Ce logiciel est conçu, développé et exploité par ILYGO Sàrl, entreprise suisse fondée en 2018 et établie dans le canton de Vaud.": {
    "de": "Konzipiert, entwickelt und betrieben von ILYGO Sàrl, einem 2018 gegründeten Schweizer Unternehmen im Kanton Waadt.",
    "en": "Designed, developed and operated by ILYGO Sàrl, a Swiss company founded in 2018 and based in the canton of Vaud."
  },
  "Dites-nous combien vous avez de places, quelles formules vous vendez et ce qui vous coûte le plus de temps aujourd’hui. Nous vous répondons avec un prix et une réponse franche, y compris quand ce logiciel n’est pas ce qu’il vous faut.": {
    "de": "Nennen Sie uns Ihre Plätze, Abonnements und grössten Zeitfresser. Wir antworten mit einem Preis und einer ehrlichen Einschätzung, auch wenn diese Software nicht zu Ihnen passt.",
    "en": "Tell us your capacity, pass types and what takes most of your time. We reply with a price and an honest answer, including when this software is not right for you."
  },
  "Facultatif.": {
    "de": "Optional.",
    "en": "Optional."
  },
  "Deux ne demandent rien à personne, la troisième vous met en face de quelqu’un. Les trois mènent au même endroit.": {
    "de": "Zwei Wege gehen ohne Anfrage, der dritte führt zum Gespräch. Alle drei führen ans gleiche Ziel.",
    "en": "Two require no contact; the third puts you in touch with a person. All three lead to the same place."
  },
  "Cette page s’adresse aux": {
    "de": "Diese Seite richtet sich an",
    "en": "This page is for"
  },
  "comme aux": {
    "de": "ebenso wie an",
    "en": "as well as"
  },
  ": un concert, une soirée d’entreprise, une fête de village. Pas de saison, pas d’abonnement, un forfait par soirée.": {
    "de": ": ein Konzert, ein Firmenanlass, ein Dorffest. Keine Saison, kein Abonnement: ein Pauschalpreis pro Abend.",
    "en": ": a concert, a corporate event, a village celebration. No season, no subscription: one flat fee per evening."
  },
  "Cette offre est en préparation : écrivez-nous": {
    "de": "Dieses Angebot ist in Vorbereitung: Schreiben Sie uns",
    "en": "This offer is being prepared: contact us"
  },
  "Le détail et le tarif": {
    "de": "Details und Preise",
    "en": "Details and pricing"
  },
  "Suite de billetterie pour salles de spectacle et événements · ILYGO": {
    "de": "Ticketing für Veranstaltungsorte und Events · ILYGO",
    "en": "Ticketing suite for venues and events · ILYGO"
  },
  "Aller au contenu": {
    "de": "Zum Inhalt",
    "en": "Skip to content"
  },
  "La saison, en ligne": {
    "de": "Die Saison online",
    "en": "The season online"
  },
  "Vos spectacles, leurs dates et leur disponibilité : « places disponibles », « dernières places », « complet ». Filtrable par spectacle et par date.": {
    "de": "Ihre Veranstaltungen, Termine und Verfügbarkeit: freie Plätze, letzte Plätze, ausverkauft. Nach Veranstaltung und Datum filterbar.",
    "en": "Your shows, dates and availability: seats available, last seats, sold out. Filter by show and date."
  },
  "La place, sur le plan": {
    "de": "Der Platz im Saalplan",
    "en": "A seat on the seating plan"
  },
  "Le spectateur choisit son fauteuil sur le plan de votre salle, celui-là même que voit votre guichet. Les sièges retenus le sont pour tout le monde, le temps de finir la commande.": {
    "de": "Das Publikum wählt seinen Sitzplatz im selben Saalplan wie Ihre Kasse. Die ausgewählten Plätze bleiben für alle reserviert, bis die Bestellung abgeschlossen ist.",
    "en": "Customers choose their seat on the same seating plan your box office uses. Selected seats are held for everyone while the order is completed."
  },
  "Ses coordonnées, rien de plus": {
    "de": "Kontaktdaten, sonst nichts",
    "en": "Contact details, nothing more"
  },
  "Aucun compte à créer, aucun mot de passe à retenir. Un nom, une adresse électronique, et la commande part.": {
    "de": "Kein Konto erstellen, kein Passwort merken. Ein Name, eine E-Mail-Adresse, und die Bestellung wird abgeschickt.",
    "en": "No account to create, no password to remember. A name, an email address, and the order is sent."
  },
  "Ses billets et sa facture": {
    "de": "Tickets und Rechnung",
    "en": "Tickets and invoice"
  },
  "Les billets PDF et la facture QR suisse arrivent par courriel, à votre nom et sur votre IBAN. Vous saisissez l’encaissement quand le virement arrive.": {
    "de": "Die PDF-Tickets und die Schweizer QR-Rechnung kommen per E-Mail, unter Ihrem Namen und mit Ihrer IBAN. Sie erfassen den Zahlungseingang, sobald die Überweisung eintrifft.",
    "en": "PDF tickets and the Swiss QR-bill arrive by email, in your name and with your IBAN. You record payment when the transfer arrives."
  },
  "La vente au public": {
    "de": "Verkauf an das Publikum",
    "en": "Public ticket sales"
  },
  "Une boutique ouverte quand votre guichet ne l’est pas": {
    "de": "Ein Onlineshop, der auch nach Kassenschluss geöffnet bleibt",
    "en": "A shop that stays open when your box office closes"
  },
  "Les sièges choisis sont retenus": {
    "de": "Die ausgewählten Plätze bleiben reserviert",
    "en": "Selected seats are held"
  },
  "quinze minutes par défaut": {
    "de": "standardmässig fünfzehn Minuten",
    "en": "for fifteen minutes by default"
  },
  "(le délai se règle entre cinq et trente minutes selon votre salle), le compte à rebours est visible pendant toute la commande, et le spectateur peut le prolonger une fois si personne n’attend ces places. Votre guichet dispose du même parcours pour une commande prise au téléphone : on ne maintient pas deux façons de vendre la même place. Et si la vente en ligne n’est pas ouverte, campagne de réabonnement en cours ou saison pas encore publiée, la boutique reste visible et l’explique au visiteur, en français, plutôt que de disparaître.": {
    "de": "(einstellbar zwischen fünf und dreissig Minuten). Der Countdown bleibt während der gesamten Bestellung sichtbar. Wartet niemand auf diese Plätze, kann das Publikum einmal verlängern. Für telefonische Bestellungen nutzt Ihre Kasse denselben Ablauf: keine zwei Verkaufswege für denselben Platz. Ist der Onlineverkauf noch geschlossen, etwa während der Abonnementkampagne oder vor Veröffentlichung der Saison, bleibt der Shop sichtbar und erklärt den Grund auf Französisch.",
    "en": "(configurable from five to thirty minutes). The countdown stays visible throughout the order, and customers may extend it once if nobody is waiting for those seats. Your box office uses the same flow for telephone orders: there are not two ways to sell the same seat. If online sales are not yet open, during the renewal campaign or before publication of the season, the shop remains visible and explains why in French."
  },
  "Ce que la boutique ne fait pas": {
    "de": "Was der Shop nicht leistet",
    "en": "What the shop does not do"
  },
  "Monter la saison": {
    "de": "Die Saison aufbauen",
    "en": "Set up the season"
  },
  "Spectacles, représentations datées, matrices tarifaires par zone et par catégorie de public, formules d’abonnement. La composition d’une série se fait sur des représentations précises : le Cyrano du mardi, pas celui du mercredi.": {
    "de": "Veranstaltungen, datierte Vorstellungen, Preismatrizen nach Zone und Publikumskategorie, Abonnements. Eine Serie besteht aus konkreten Vorstellungen: Cyrano am Dienstag, nicht am Mittwoch.",
    "en": "Shows, dated performances, price matrices by zone and audience category, and season passes. A series contains specific performances: Tuesday’s Cyrano, not Wednesday’s."
  },
  "Début juin": {
    "de": "Anfang Juni",
    "en": "Early June"
  },
  "Générer les propositions": {
    "de": "Vorschläge erstellen",
    "en": "Generate proposals"
  },
  "Vous faites d’abord correspondre les formules de l’an passé à celles de la nouvelle saison : un choix humain, jamais une devinette. Le système crée ensuite une proposition par abonné, avec son siège. Les sièges devenus incompatibles partent dans une liste « à replacer » que vous arbitrez une par une.": {
    "de": "Zuerst ordnen Sie die bisherigen Abonnements den Angeboten der neuen Saison zu: eine menschliche Entscheidung, kein Ratespiel. Danach erstellt das System pro Abonnent einen Vorschlag mit Sitzplatz. Nicht mehr passende Plätze kommen auf eine Liste zur individuellen Neuzuteilung.",
    "en": "First, you match last year’s passes to the new season’s offers: a human decision, not a guess. The system then creates one proposal per subscriber, including their seat. Incompatible seats go onto a reassignment list for individual review."
  },
  "Juin · phase interne": {
    "de": "Juni · interne Phase",
    "en": "June · internal phase"
  },
  "Traiter les bulletins": {
    "de": "Antwortformulare bearbeiten",
    "en": "Process renewal forms"
  },
  "Les sièges proposés sont gelés : personne ne peut les vendre à quelqu’un d’autre. Pour chaque bulletin reçu : accepter, déplacer les sièges sur le plan puis accepter, ou décliner. Un refus libère la place immédiatement, sans attendre la fin de la phase.": {
    "de": "Vorgeschlagene Plätze sind gesperrt und können nicht anderweitig verkauft werden. Für jedes Antwortformular: annehmen, im Plan umplatzieren und annehmen oder ablehnen. Eine Ablehnung gibt den Platz sofort frei, ohne das Ende der Phase abzuwarten.",
    "en": "Proposed seats are held and cannot be sold to anyone else. For each returned form: accept, move seats on the plan and accept, or decline. Declining releases the seat immediately, without waiting for the phase to end."
  },
  "15 août": {
    "de": "15. August",
    "en": "15 August"
  },
  "Ouvrir au public": {
    "de": "Für das Publikum öffnen",
    "en": "Open to the public"
  },
  "Vous pressez le bouton, pas l’horloge. Le système affiche un récapitulatif avant confirmation : « 37 propositions encore en attente vont expirer et libérer 61 sièges ». Il libère ensuite les places et ouvre la vente au guichet.": {
    "de": "Sie drücken den Knopf, nicht die Uhr. Vor der Bestätigung zeigt das System eine Zusammenfassung: «37 offene Vorschläge laufen aus und geben 61 Plätze frei». Danach gibt es die Plätze frei und öffnet den Kassenverkauf.",
    "en": "You press the button; the clock does not. Before confirmation, the system shows a summary: “37 pending proposals will expire and release 61 seats”. It then releases the seats and opens box-office sales."
  },
  "Ce que votre billetterie ne fait pas": {
    "de": "Was Ihr Ticketing nicht leistet",
    "en": "What your ticketing system does not do"
  },
  "La campagne de réabonnement": {
    "de": "Die Abonnementverlängerung",
    "en": "The season-pass renewal campaign"
  },
  "Vos abonnés retrouvent leur fauteuil sans que personne ne tienne un fichier : le logiciel reconduit les places de l’an passé, les gèle jusqu’à l’ouverture au public, et n’oublie personne.": {
    "de": "Ihre Abonnenten behalten ihren Platz ohne separate Datei: Die Software übernimmt die Plätze aus der Vorsaison, hält sie bis zum öffentlichen Verkauf frei und vergisst niemanden.",
    "en": "Subscribers keep their seats without anyone maintaining a separate file: the software carries seats over from last season, holds them until public sales open, and leaves nobody out."
  },
  "Pendant toute la phase interne": {
    "de": "Während der gesamten internen Phase",
    "en": "Throughout the internal phase"
  },
  ", la vente à l’unité est bloquée : on ne vend pas au public des places que la campagne n’a pas encore arbitrées. Un administrateur peut déroger ponctuellement ; la dérogation est journalisée.": {
    "de": ", ist der Einzelverkauf gesperrt: Noch nicht zugeteilte Kampagnenplätze werden nicht öffentlich verkauft. Administratoren können begründete Ausnahmen machen; diese werden protokolliert.",
    "en": ", single-ticket sales are blocked: seats not yet settled by the campaign are not sold to the public. An administrator can grant an occasional exception, which is logged."
  },
  "Vos abonnés n’ont rien à faire en ligne": {
    "de": "Ihre Abonnenten müssen nichts online erledigen",
    "en": "Subscribers do not have to do anything online"
  },
  "La campagne fonctionne sur bulletin papier, au téléphone et au guichet : c’est votre équipe qui saisit les réponses, exactement comme aujourd’hui. L’espace abonné est un supplément, jamais un passage obligé : un abonné sans adresse électronique reste un abonné comme les autres, avec sa carte, ses billets et sa place.": {
    "de": "Die Kampagne funktioniert per Papierformular, Telefon und an der Kasse: Ihr Team erfasst die Antworten wie bisher. Das Abonnentenportal ist eine Ergänzung, keine Pflicht. Auch ohne E-Mail-Adresse erhält jeder seine Karte, Tickets und seinen Platz.",
    "en": "The campaign works through paper forms, telephone calls and the box office: your team records replies just as it does today. The subscriber portal is an extra, never mandatory. Subscribers without email still have their card, tickets and seat."
  },
  "À notre connaissance, et au terme d’un relevé du 19.08.2026 : aucune billetterie suisse à tarif public ne documente la reconduction du même siège d’une saison sur l’autre. Le relevé couvre les offres dont le tarif est publié ; quatre acteurs du marché ne publient pas le leur et n’ont donc pas pu être vérifiés.": {
    "de": "Nach unserem Kenntnisstand und einer Erhebung vom 19.08.2026 dokumentiert kein Schweizer Ticketing-Angebot mit öffentlichen Preisen die Übernahme desselben Sitzplatzes in die nächste Saison. Die Erhebung umfasst Angebote mit veröffentlichten Preisen; vier Anbieter ohne öffentliche Preise konnten nicht geprüft werden.",
    "en": "To our knowledge, following a survey dated 19 August 2026, no Swiss ticketing offer with public pricing documents carrying the same seat from one season to the next. The survey covers published-price offers; four providers without public pricing could not be checked."
  },
  "Indiquez votre nom.": {
    "de": "Geben Sie Ihren Namen an.",
    "en": "Enter your name."
  },
  "Indiquez le nom de votre salle ou de votre compagnie.": {
    "de": "Geben Sie den Namen Ihres Hauses oder Ihrer Gruppe an.",
    "en": "Enter the name of your venue or company."
  },
  "Indiquez une adresse électronique valable, pour que nous puissions répondre.": {
    "de": "Geben Sie eine gültige E-Mail-Adresse für unsere Antwort an.",
    "en": "Enter a valid email address so we can reply."
  },
  "Dites-nous en quelques mots ce que vous cherchez.": {
    "de": "Beschreiben Sie kurz, was Sie suchen.",
    "en": "Tell us briefly what you are looking for."
  },
  "Votre message n’a pas pu être envoyé.": {
    "de": "Ihre Nachricht konnte nicht gesendet werden.",
    "en": "Your message could not be sent."
  },
  "Parlons de votre salle": {
    "de": "Sprechen wir über Ihr Haus",
    "en": "Let’s talk about your venue"
  },
  "Écrivez-nous : nous répondons en deux jours ouvrables": {
    "de": "Schreiben Sie uns: Wir antworten innerhalb von zwei Arbeitstagen",
    "en": "Contact us: we reply within two working days"
  },
  "Message non envoyé": {
    "de": "Nachricht nicht gesendet",
    "en": "Message not sent"
  },
  "Ouvrir un message pré-rempli": {
    "de": "Vorbereitete Nachricht öffnen",
    "en": "Open a pre-filled message"
  },
  "Écrivez-nous directement à": {
    "de": "Schreiben Sie direkt an",
    "en": "Email us directly at"
  },
  "Votre nom": {
    "de": "Ihr Name",
    "en": "Your name"
  },
  "Votre salle ou compagnie": {
    "de": "Ihr Haus oder Ihre Gruppe",
    "en": "Your venue or company"
  },
  "Adresse électronique": {
    "de": "E-Mail-Adresse",
    "en": "Email address"
  },
  "Téléphone": {
    "de": "Telefon",
    "en": "Phone"
  },
  "Votre message": {
    "de": "Ihre Nachricht",
    "en": "Your message"
  },
  "Nombre de places, formules vendues, échéance : plus c’est précis, plus la réponse l’est.": {
    "de": "Sitzplätze, Abonnements, Termin: Je genauer Ihre Angaben, desto genauer unsere Antwort.",
    "en": "Capacity, pass types and deadlines: the more specific your question, the more useful our reply."
  },
  "Site web (ne pas remplir)": {
    "de": "Website (nicht ausfüllen)",
    "en": "Website (leave empty)"
  },
  "Envoi en cours…": {
    "de": "Wird gesendet…",
    "en": "Sending…"
  },
  "Envoyer ma demande": {
    "de": "Anfrage senden",
    "en": "Send my enquiry"
  },
  "Votre message part chez l’éditeur, ILYGO Sàrl. Rien n’est transmis à un tiers.": {
    "de": "Ihre Nachricht geht an den Herausgeber ILYGO Sàrl. Sie wird nicht an Dritte weitergegeben.",
    "en": "Your message goes to the publisher, ILYGO Sàrl. Nothing is shared with third parties."
  },
  "Nous répondons depuis": {
    "de": "Wir antworten von",
    "en": "We reply from"
  },
  ": si notre réponse tarde, regardez dans vos indésirables.": {
    "de": ": Falls unsere Antwort ausbleibt, prüfen Sie Ihren Spamordner.",
    "en": ": if our reply is late, check your spam folder."
  },
  "Écrire un autre message": {
    "de": "Weitere Nachricht schreiben",
    "en": "Write another message"
  },
  "Avant tout": {
    "de": "Zuerst",
    "en": "First things first"
  },
  "Votre salle, décrite une fois": {
    "de": "Ihr Saal, einmal erfasst",
    "en": "Your venue, set up once"
  },
  "Plan de salle par zones tarifaires, sièges créés par lots ou par import CSV, sièges hors vente pour la régie et les emplacements pour fauteuils roulants.": {
    "de": "Saalplan nach Preiszonen, Plätze per Stapelerstellung oder CSV-Import, nicht verkäufliche Plätze für die Regie und Rollstuhlplätze.",
    "en": "A seating plan with price zones, seats created in batches or imported from CSV, seats held back for operations, and wheelchair spaces."
  },
  "Plusieurs salles par théâtre, vos catégories de public et vos déductions, vos comptes et leurs rôles.": {
    "de": "Mehrere Säle pro Theater, Ihre Publikumskategorien und Abzüge, Ihre Konten und Rollen.",
    "en": "Multiple rooms per theatre, your audience categories and deductions, your accounts and roles."
  },
  "Le plan se verrouille au premier billet vendu : plus personne ne supprime le rang F en cours d’exploitation.": {
    "de": "Der Plan wird mit dem ersten verkauften Ticket gesperrt: Niemand löscht während der Saison Reihe F.",
    "en": "The plan locks when the first ticket is sold: nobody can delete row F during the season."
  },
  "En mai": {
    "de": "Im Mai",
    "en": "In May"
  },
  "La saison, montée sans fichier à préparer": {
    "de": "Die Saison aufbauen, ohne eine Datei vorzubereiten",
    "en": "Build the season without preparing a file"
  },
  "Saisons, spectacles, représentations datées, salle par représentation.": {
    "de": "Saisons, Veranstaltungen, datierte Vorstellungen und ein Saal pro Vorstellung.",
    "en": "Seasons, shows, dated performances and a room for each performance."
  },
  "Matrices de prix par zone et par catégorie de public, à l’échelle d’un spectacle, d’une formule ou de la saison entière. Elles se recopient d’une saison sur l’autre.": {
    "de": "Preismatrizen nach Zone und Publikumskategorie für eine Veranstaltung, ein Abonnement oder die ganze Saison. Sie lassen sich in die nächste Saison kopieren.",
    "en": "Price matrices by zone and audience category, for a show, a pass or the entire season. Copy them from one season to the next."
  },
  "Trois natures de formule : série imposée, N spectacles au choix, carnet d’entrées.": {
    "de": "Drei Abonnementarten: feste Serie, N Veranstaltungen nach Wahl, Eintrittskarte mit Guthaben.",
    "en": "Three pass types: a fixed series, N shows of your choice, or a book of admissions."
  },
  "De juin à mai": {
    "de": "Von Juni bis Mai",
    "en": "From June to May"
  },
  "La vente, au guichet et en ligne": {
    "de": "Verkauf an der Kasse und online",
    "en": "Sales at the box office and online"
  },
  "Guichet : vente sur plan interactif, tarifs réduits, invitations, annulation tracée, et vente téléphonique par le même parcours que la boutique.": {
    "de": "Kasse: Verkauf im interaktiven Plan, ermässigte Tarife, Einladungen, protokollierte Stornierungen und Telefonverkauf über denselben Ablauf wie im Shop.",
    "en": "Box office: sales on an interactive plan, reduced prices, invitations, logged cancellations and telephone sales through the same flow as the shop."
  },
  "Boutique en ligne pour le public": {
    "de": "Onlineshop für das Publikum",
    "en": "An online shop for the public"
  },
  ": la saison, le choix de la place sur le plan de la salle, un panier qui retient les sièges le temps de la commande, et aucun compte à créer pour acheter.": {
    "de": ": Saisonübersicht, Sitzplatzwahl im Saalplan, ein Warenkorb mit Platzreservierung während der Bestellung und Kauf ohne Konto.",
    "en": ": the season, seat selection on the plan, a basket that holds seats during checkout, and no account required to buy."
  },
  "Chèques culture et déductions par type, ajustements motivés, dérogations journalisées.": {
    "de": "Kulturgutscheine und Abzüge nach Art, begründete Korrekturen und protokollierte Ausnahmen.",
    "en": "Culture vouchers and deductions by type, adjustments with reasons, and logged exceptions."
  },
  "Chaque printemps": {
    "de": "Jeden Frühling",
    "en": "Every spring"
  },
  "Phases datées, bulletins, propositions de sièges reprises de la saison passée, sièges gelés jusqu’à l’ouverture au public.": {
    "de": "Datierte Phasen, Antwortformulare, Sitzplatzvorschläge aus der Vorsaison und bis zum öffentlichen Verkauf gesperrte Plätze.",
    "en": "Dated phases, renewal forms, seat proposals carried over from last season, and seats held until public sales open."
  },
  "Liste « à replacer » arbitrée une par une, correspondances de formules d’une saison à l’autre.": {
    "de": "Individuell bearbeitete Neuzuteilungen und Zuordnung der Abonnements zwischen den Saisons.",
    "en": "Individual seat reassignments and pass matching from one season to the next."
  },
  "Écran de suivi chiffré, et ouverture publique déclenchée par vous, pas par l’horloge.": {
    "de": "Eine bezifferte Übersicht und eine öffentliche Öffnung, die Sie auslösen, nicht die Uhr.",
    "en": "A quantified progress screen, with public sales opened by you, not by the clock."
  },
  "Le soir même": {
    "de": "Am Abend",
    "en": "On the night"
  },
  "Les documents, puis la porte": {
    "de": "Erst die Dokumente, dann der Einlass",
    "en": "Documents first, then admission"
  },
  "Facture QR suisse": {
    "de": "Schweizer QR-Rechnung",
    "en": "Swiss QR-bill"
  },
  "conforme à la norme SIX, émise avec les billets PDF et les cartes d’abonné, à votre nom et sur votre propre IBAN. Le statut d’envoi reste visible, et un bouton « renvoyer » est à portée de votre guichet.": {
    "de": "nach SIX-Standard, zusammen mit PDF-Tickets und Abonnentenkarten, unter Ihrem Namen und mit Ihrer IBAN. Der Versandstatus bleibt sichtbar, und Ihre Kasse kann jederzeit erneut senden.",
    "en": "compliant with the SIX standard, issued with PDF tickets and subscriber cards, in your name and with your own IBAN. Delivery status stays visible, with a resend button within reach of your box office."
  },
  "Relances des impayés échelonnées, dont vous choisissez les destinataires et le moment.": {
    "de": "Gestaffelte Zahlungserinnerungen: Sie wählen Empfänger und Zeitpunkt.",
    "en": "Staged overdue-payment reminders: you choose the recipients and timing."
  },
  "Contrôle d’accès au téléphone : billets et cartes, verdict lisible à un mètre, doublons détectés, mode hors ligne préparé avant la soirée, liste d’émargement imprimable.": {
    "de": "Einlasskontrolle am Telefon: Tickets und Karten, auf einen Meter lesbares Ergebnis, Erkennung doppelter Eintritte, vorab vorbereiteter Offlinemodus und druckbare Einlassliste.",
    "en": "Admission checks by phone: tickets and cards, a result readable from a metre away, duplicate detection, offline mode prepared before the event, and a printable attendance list."
  },
  "Toute l’année": {
    "de": "Das ganze Jahr",
    "en": "All year round"
  },
  "Ce que vous regardez, et ce que vous reprenez": {
    "de": "Was Sie sehen und übernehmen",
    "en": "What you monitor and carry over"
  },
  "Tableaux de bord : remplissage par représentation, santé de la campagne, recettes, impayés. Tout est exportable en CSV.": {
    "de": "Dashboards: Auslastung pro Vorstellung, Kampagnenstand, Einnahmen und offene Zahlungen. Alles als CSV exportierbar.",
    "en": "Dashboards: occupancy per performance, campaign progress, revenue and unpaid amounts. Everything exports to CSV."
  },
  "Espace abonné, vos couleurs, votre police et votre logo sur toutes les pages que voit votre public.": {
    "de": "Abonnentenportal, Ihre Farben, Ihre Schrift und Ihr Logo auf allen öffentlichen Seiten.",
    "en": "A subscriber portal, your colours, font and logo on every page your audience sees."
  },
  "Reprise de vos fichiers : import en deux temps, simulation commentée puis validation, pour que la première campagne parte avec l’historique. Douze outils de déblocage et un journal d’audit inaltérable.": {
    "de": "Übernahme Ihrer Dateien in zwei Schritten: kommentierte Simulation und Bestätigung, damit die erste Kampagne mit dem bisherigen Verlauf startet. Zwölf Entsperrwerkzeuge und ein unveränderbares Auditprotokoll.",
    "en": "Bring in your files in two steps: an explained simulation followed by confirmation, so the first campaign starts with its history. Twelve recovery tools and an immutable audit log."
  },
  "Ce que ça fait": {
    "de": "Funktionen",
    "en": "What it does"
  },
  "De la salle vide au soir de première": {
    "de": "Vom leeren Saal bis zur Premiere",
    "en": "From an empty venue to opening night"
  },
  "Ce n’est pas un module de plus à côté de votre billetterie : c’est votre billetterie.": {
    "de": "Kein Zusatzmodul neben Ihrem Ticketing: Das ist Ihr Ticketing.",
    "en": "Not another module beside your ticketing system: this is your ticketing system."
  },
  "Plan de salle, guichet, boutique en ligne, facturation, contrôle d’accès, tableaux de bord : la chaîne entière est là, dans un seul forfait, sans module en supplément ni option à débloquer.": {
    "de": "Saalplan, Kasse, Onlineshop, Rechnungen, Einlasskontrolle und Dashboards: die ganze Kette in einer Pauschale, ohne Zusatzmodule oder freizuschaltende Optionen.",
    "en": "Seating plan, box office, online shop, invoicing, admission checks and dashboards: the entire chain in one flat fee, with no extra modules or options to unlock."
  },
  "Les pièces qui sortent de chez vous": {
    "de": "Dokumente aus Ihrem Haus",
    "en": "Documents from your venue"
  },
  "Ce que reçoivent vos spectateurs": {
    "de": "Was Ihr Publikum erhält",
    "en": "What your audience receives"
  },
  "Le billet": {
    "de": "Das Ticket",
    "en": "The ticket"
  },
  "Chaque représentation réservée donne lieu à un billet individuel avec sa date, sa place et son QR. Pour une série de huit représentations, les huit billets sont émis dès la confirmation. Pour une formule au choix ou un carnet, chaque billet naît à la réservation de sa représentation. Ils se téléchargent dans l’espace abonné et se réimpriment au guichet.": {
    "de": "Für jede reservierte Vorstellung entsteht ein eigenes Ticket mit Datum, Platz und QR-Code. Bei einer Serie mit acht Vorstellungen werden alle acht Tickets bei der Bestätigung ausgestellt. Bei einem Wahlabonnement oder Eintrittsbuch entsteht jedes Ticket erst bei der Reservierung. Die Tickets können im Abonnentenportal heruntergeladen und an der Kasse erneut gedruckt werden.",
    "en": "Each booked performance has an individual ticket with its date, seat and QR code. For a series of eight performances, all eight tickets are issued on confirmation. For a choice pass or admission book, each ticket is issued when that performance is booked. Tickets can be downloaded from the subscriber portal and printed again at the box office."
  },
  "À l’entrée, l’abonné présente sa carte ou le billet de la représentation. Les deux supports valident la même place : en ligne, après un premier passage, l’autre est signalé comme déjà utilisé.": {
    "de": "Am Eingang zeigt die abonnierende Person ihre Karte oder das Ticket für die Vorstellung. Beide Nachweise gelten für denselben Platz: Bei Online-Kontrolle wird der andere nach dem ersten Zutritt als bereits verwendet gemeldet.",
    "en": "At the entrance, the subscriber presents their card or the ticket for that performance. Both validate the same seat: during online checks, the other is flagged as already used after the first admission."
  },
  "La facture QR suisse": {
    "de": "Die Schweizer QR-Rechnung",
    "en": "The Swiss QR-bill"
  },
  "Conforme à la norme SIX : récépissé et section paiement détachables, QR-IBAN et référence structurée à vingt-sept chiffres. Votre client la scanne dans son application bancaire, et le virement arrive": {
    "de": "Nach SIX-Standard: abtrennbarer Empfangsschein und Zahlteil, QR-IBAN und strukturierte 27-stellige Referenz. Ihr Kunde scannt sie in seiner Banking-App; die Überweisung geht",
    "en": "Compliant with the SIX standard: detachable receipt and payment section, QR-IBAN and a structured 27-digit reference. Customers scan it in their banking app; the transfer arrives"
  },
  "sur votre propre IBAN": {
    "de": "auf Ihre eigene IBAN",
    "en": "in your own bank account"
  },
  ", au nom de votre association. L’argent ne transite jamais par nous.": {
    "de": ", auf den Namen Ihres Vereins. Das Geld läuft niemals über uns.",
    "en": ", in your association’s name. The money never passes through us."
  },
  "Stripe peut être activé sur le compte de votre organisme depuis la console. Pour un autre prestataire, nous réalisons une intégration spécifique, devisée à part. Dans tous les cas, le contrat et les montants restent les vôtres.": {
    "de": "Stripe kann mit dem Konto Ihrer Organisation über die Konsole aktiviert werden. Für andere Zahlungsanbieter bieten wir eine gesondert offerierte Integration an. Vertrag und Zahlungen bleiben in jedem Fall bei Ihnen.",
    "en": "Stripe can be activated with your organisation’s own account from the console. Other payment providers require a separately quoted integration. In every case, the contract and funds remain yours."
  },
  "La carte d’abonné": {
    "de": "Die Abonnentenkarte",
    "en": "The subscriber card"
  },
  "Chaque abonnement est nominatif et donne droit à une place par représentation couverte. Pour deux places, il faut deux abonnements distincts, chacun avec son titulaire et sa carte. Le QR de chaque carte ne contient": {
    "de": "Jedes Abonnement ist persönlich und berechtigt zu einem Platz pro abgedeckter Vorstellung. Für zwei Plätze braucht es zwei getrennte Abonnements, jedes mit eigener Inhaberin oder eigenem Inhaber und eigener Karte. Der QR-Code jeder Karte enthält",
    "en": "Each subscription is personal and grants one seat per covered performance. Two seats require two separate subscriptions, each with its own holder and card. Each card’s QR code contains"
  },
  "aucune donnée": {
    "de": "keine Daten",
    "en": "no data"
  },
  ": un jeton aléatoire, illisible sans le serveur. Perdue ? Vous la régénérez : l’ancien QR est refusé au scan dans la seconde, le nouveau part par courriel.": {
    "de": ": ein zufälliger Token, ohne Server nicht lesbar. Karte verloren? Sie erstellen eine neue: Der alte QR-Code wird sofort abgewiesen, der neue per E-Mail versendet.",
    "en": ": a random token, unreadable without the server. Lost card? Regenerate it: the old QR code is rejected immediately, and the new one is emailed."
  },
  "Et la commande, telle que le spectateur la termine": {
    "de": "Die Bestellung beim Abschluss",
    "en": "The order at checkout"
  },
  "Le récapitulatif, le montant à régler, les billets à télécharger et la facture QR, sur le même écran, puis le courriel qui les emporte. Le règlement se fait par la facture, depuis l’application bancaire de votre client.": {
    "de": "Zusammenfassung, offener Betrag, Tickets zum Herunterladen und QR-Rechnung auf einem Bildschirm, danach gemeinsam per E-Mail. Bezahlt wird über die Rechnung in der Banking-App Ihres Kunden.",
    "en": "The summary, amount due, downloadable tickets and QR-bill on one screen, followed by the email carrying them. Customers pay the bill from their banking app."
  },
  "Chaque envoi porte son statut (parti, en échec, jamais envoyé) et un bouton « renvoyer » que votre guichet actionne sans passer par nous. Les relances des impayés existent : le logiciel vous dit qui doit combien et depuis quand, et c’est un humain qui choisit les destinataires et déclenche l’envoi.": {
    "de": "Jeder Versand zeigt seinen Status: gesendet, fehlgeschlagen oder nie versendet. Ihre Kasse kann ohne unsere Hilfe erneut senden. Zahlungserinnerungen sind vorhanden: Die Software zeigt, wer seit wann wie viel schuldet; ein Mensch wählt die Empfänger und löst den Versand aus.",
    "en": "Each delivery shows its status: sent, failed or never sent, with a resend button your box office can use without contacting us. Overdue reminders are available: the software shows who owes how much and since when; a person chooses the recipients and sends them."
  },
  "Qui édite ce logiciel": {
    "de": "Wer diese Software herausgibt",
    "en": "Who publishes this software"
  },
  "Édité par ILYGO, en Suisse": {
    "de": "Von ILYGO, in der Schweiz",
    "en": "Published by ILYGO, in Switzerland"
  },
  "Nous détenons l’intégralité du code source.": {
    "de": "Wir besitzen den gesamten Quellcode.",
    "en": "We own the entire source code."
  },
  "Il n’y a, entre votre théâtre et le logiciel, aucun éditeur tiers, aucune brique sous licence dont dépendrait votre avenir. Quand vous demandez une évolution, la seule question est de savoir si elle est juste et combien de temps elle prend, jamais de savoir si un fournisseur voudra bien la faire.": {
    "de": "Zwischen Ihrem Theater und der Software steht kein Dritthersteller und kein Lizenzbaustein, von dem Ihre Zukunft abhängt. Bei einer gewünschten Weiterentwicklung zählt, ob sie sinnvoll ist und wie lange sie dauert, nicht ob ein Lieferant sie umsetzen will.",
    "en": "There is no third-party publisher or licensed component standing between your theatre and the software’s future. When you request a change, the question is whether it makes sense and how long it takes, not whether a supplier agrees to build it."
  },
  "Nous adaptons le logiciel à votre maison.": {
    "de": "Wir passen die Software an Ihr Haus an.",
    "en": "We adapt the software to your venue."
  },
  "Un théâtre a ses formules, ses habitudes, son vocabulaire : on ne compose pas un carnet de la même façon d’une salle à l’autre, on n’attribue pas les places dans le même ordre. Nous ajustons le produit à vos usages plutôt que de vous demander de changer les vôtres.": {
    "de": "Jedes Theater hat eigene Abonnements, Abläufe und Begriffe. Guthabenkarten werden unterschiedlich zusammengestellt, Plätze anders zugeteilt. Wir passen das Produkt an Ihre Arbeit an, statt von Ihnen neue Gewohnheiten zu verlangen.",
    "en": "Every theatre has its own passes, habits and terminology: admission books are composed differently, and seats allocated in a different order. We adapt the product to your practices instead of asking you to change them."
  },
  "Vos données restent en Suisse": {
    "de": "Ihre Daten bleiben in der Schweiz",
    "en": "Your data stays in Switzerland"
  },
  ", sur une infrastructure que nous exploitons nous-mêmes, avec des sauvegardes quotidiennes. Rien n’est revendu, rien n’est cédé à un tiers.": {
    "de": ", auf einer von uns betriebenen Infrastruktur mit täglichen Sicherungen. Nichts wird verkauft oder an Dritte weitergegeben.",
    "en": ", on infrastructure we operate ourselves, with daily backups. Nothing is resold or handed to third parties."
  },
  "Vous avez un seul interlocuteur.": {
    "de": "Sie haben eine einzige Ansprechperson.",
    "en": "You have one point of contact."
  },
  "Pas de centre d’appel, pas de numéro de ticket : l’équipe qui vous répond est celle qui connaît le produit, et qui l’a écrit.": {
    "de": "Kein Callcenter, keine Ticketnummer: Das Team, das Ihnen antwortet, kennt das Produkt und hat es geschrieben.",
    "en": "No call centre, no ticket number: the team replying knows the product and wrote it."
  },
  "Si nous devions abandonner ce produit.": {
    "de": "Falls wir dieses Produkt aufgeben müssten.",
    "en": "If we had to discontinue this product."
  },
  "Si ILYGO décidait, ou était contrainte, de cesser l’exploitation de cette billetterie, le code source de la plateforme serait rendu open source et mis à la libre disposition des théâtres alors sous abonnement en cours à cette date. Cet engagement ne promet pas la continuité du service : « open source » ne veut pas dire « maintenu », et rien ici ne garantit qu’une équipe reprenne le support. Ce qu’il garantit, c’est de ne jamais vous laisser prisonnier d’un logiciel fermé, et la possibilité de faire reprendre le code par un prestataire de votre choix.": {
    "de": "Sollte ILYGO den Betrieb dieses Ticketings freiwillig oder gezwungenermassen einstellen, würde der Quellcode als Open Source veröffentlicht und den zu diesem Zeitpunkt aktiv abonnierten Theatern frei zur Verfügung gestellt. Das verspricht keinen Weiterbetrieb: Open Source bedeutet nicht betreut, und niemand garantiert die Übernahme des Supports. Garantiert wird, dass Sie nicht in einer geschlossenen Software gefangen bleiben und den Code von einem Anbieter Ihrer Wahl weiterführen lassen können.",
    "en": "If ILYGO chose or was forced to stop operating this ticketing system, the platform’s source code would be released as open source and made freely available to theatres with an active subscription at that date. This does not promise continuity of service: open source does not mean maintained, nor does it guarantee someone will take over support. It guarantees that you will not be trapped in closed software and can have a provider of your choice take over the code."
  },
  "ILYGO Sàrl · canton de Vaud, Suisse · IDE": {
    "de": "ILYGO Sàrl · Kanton Waadt, Schweiz · UID",
    "en": "ILYGO Sàrl · canton of Vaud, Switzerland · UID"
  },
  "ilygo.ch": {
    "de": "ilygo.ch",
    "en": "ilygo.ch"
  },
  "jusqu’à 100 billets": {
    "de": "bis 100 Tickets",
    "en": "up to 100 tickets"
  },
  "CHF 50.–": {
    "de": "CHF 50.–",
    "en": "CHF 50.–"
  },
  "101 à 500 billets": {
    "de": "101 bis 500 Tickets",
    "en": "101 to 500 tickets"
  },
  "CHF 100.–": {
    "de": "CHF 100.–",
    "en": "CHF 100.–"
  },
  "501 à 2’000 billets": {
    "de": "501 bis 2’000 Tickets",
    "en": "501 to 2,000 tickets"
  },
  "CHF 200.–": {
    "de": "CHF 200.–",
    "en": "CHF 200.–"
  },
  "au-delà de 2’000 billets": {
    "de": "über 2’000 Tickets",
    "en": "over 2,000 tickets"
  },
  "sur devis": {
    "de": "auf Anfrage",
    "en": "on request"
  },
  "Une seule soirée ?": {
    "de": "Nur ein Abend?",
    "en": "Just one evening?"
  },
  "Le forfait par événement": {
    "de": "Die Veranstaltungspauschale",
    "en": "The per-event flat fee"
  },
  "Un forfait unique, qui dépend du nombre de billets émis pour la soirée.": {
    "de": "Eine einmalige Pauschale, abhängig von der Anzahl ausgestellter Tickets für den Abend.",
    "en": "One flat fee, based on the number of tickets issued for the evening."
  },
  "Cette offre est en préparation. Écrivez-nous :": {
    "de": "Dieses Angebot ist in Vorbereitung. Schreiben Sie uns:",
    "en": "This offer is being prepared. Contact us:"
  },
  "nous vous dirons où elle en est": {
    "de": "Wir sagen Ihnen, wo es steht",
    "en": "we will tell you where it stands"
  },
  ", sans enjoliver.": {
    "de": ", ohne Beschönigung.",
    "en": ", without embellishment."
  },
  "Aucun accompagnement inclus": {
    "de": "Keine Begleitung enthalten",
    "en": "No assistance included"
  },
  ": c’est du libre-service intégral, et": {
    "de": ": vollständig im Selbstbedienungsbetrieb;",
    "en": " : this is entirely self-service, and"
  },
  "la documentation est le seul appui": {
    "de": "die Dokumentation ist die einzige Unterstützung",
    "en": "the documentation is the only support"
  },
  ". Si un accompagnement devient nécessaire, il se facture à part, au tarif de la vérification (CHF 600.–). Un lieu à placement libre n’a pas d’abonnement de saison : sans siège conservé, la promesse n’aurait aucun sens.": {
    "de": ". Wird Begleitung nötig, wird sie separat zum Überprüfungstarif (CHF 600.–) verrechnet. Ein Ort mit freier Platzwahl hat keine Saisonabonnements: Ohne festen Sitzplatz wäre dieses Versprechen sinnlos.",
    "en": ". If assistance becomes necessary, it is charged separately at the review rate (CHF 600.–). A general-admission venue has no season passes: without a retained seat, the promise would make no sense."
  },
  "Série imposée": {
    "de": "Feste Serie",
    "en": "Fixed series"
  },
  "« Série Mardi »": {
    "de": "«Dienstagsserie»",
    "en": "“Tuesday Series”"
  },
  "Un programme fixé par le théâtre : huit spectacles, toujours le mardi, toujours la même place. À la confirmation, les huit billets de l’abonné naissent d’un coup.": {
    "de": "Ein vom Theater festgelegtes Programm: acht Veranstaltungen, immer dienstags, immer derselbe Platz. Bei Bestätigung entstehen alle acht Tickets der abonnierenden Person auf einmal.",
    "en": "A programme set by the theatre: eight shows, always on Tuesday, always the same seat. Confirmation creates all eight tickets for the subscriber at once."
  },
  "Le siège": {
    "de": "Der Sitzplatz",
    "en": "The seat"
  },
  "Fixé pour la saison": {
    "de": "Für die Saison festgelegt",
    "en": "Fixed for the season"
  },
  "Les billets": {
    "de": "Die Tickets",
    "en": "The tickets"
  },
  "Tous à la confirmation": {
    "de": "Alle bei Bestätigung",
    "en": "All on confirmation"
  },
  "À plusieurs, un même soir": {
    "de": "Mehrere Personen am selben Abend",
    "en": "Several people on the same evening"
  },
  "Un siège souscrit, une entrée": {
    "de": "Ein abonnierter Platz, ein Eintritt",
    "en": "One subscribed seat, one admission"
  },
  "N au choix": {
    "de": "N nach Wahl",
    "en": "Choose N shows"
  },
  "« Liberté 5 »": {
    "de": "«Freie Wahl 5»",
    "en": "“Freedom 5”"
  },
  "Un prix fixe, cinq spectacles différents à réserver au guichet ou depuis l’espace abonné. À chaque réservation, la place se choisit sur le plan.": {
    "de": "Ein Festpreis für fünf verschiedene Vorstellungen, buchbar an der Kasse oder im Abonnentenportal. Bei jeder Buchung wird der Platz auf dem Saalplan gewählt.",
    "en": "A fixed price for five different shows, booked at the box office or in the subscriber portal. Choose a seat on the seating plan for each booking."
  },
  "Choisi à chaque réservation": {
    "de": "Bei jeder Buchung gewählt",
    "en": "Chosen at each booking"
  },
  "Un par un": {
    "de": "Einzeln",
    "en": "One by one"
  },
  "Un spectacle compte une fois": {
    "de": "Jede Veranstaltung zählt einmal",
    "en": "Each show counts once"
  },
  "Carnet d’entrées": {
    "de": "Eintrittskarte mit Guthaben",
    "en": "Admission pass"
  },
  "Un nombre d’entrées défini par le théâtre, à utiliser même à plusieurs sur une soirée. Chaque place se choisit sur le plan, avec un tarif autorisé par la formule ; une entrée est décomptée par place.": {
    "de": "Das Theater legt die Anzahl Eintritte fest. Sie können auch für mehrere Personen am selben Abend genutzt werden. Jeder Platz wird auf dem Saalplan mit einem für die Formel zugelassenen Tarif gewählt; pro Platz wird ein Eintritt abgezogen.",
    "en": "The theatre sets the number of admissions. You can use them for several people on the same evening. Choose each seat on the seating plan with a fare allowed by the pass; one admission is deducted per seat."
  },
  "Choisi à chaque utilisation": {
    "de": "Bei jeder Nutzung gewählt",
    "en": "Chosen at each use"
  },
  "À chaque dépense": {
    "de": "Bei jeder Einlösung",
    "en": "On each redemption"
  },
  "Oui, autant que de crédits": {
    "de": "Ja, bis zur Höhe des Guthabens",
    "en": "Yes, up to the available credits"
  },
  "Trois natures d’abonnement": {
    "de": "Drei Abonnementarten",
    "en": "Three types of pass"
  },
  "Les formules que vous vendez déjà": {
    "de": "Die Abonnements, die Sie bereits verkaufen",
    "en": "The passes you already sell"
  },
  "Elles ne diffèrent que sur deux points, mais ces deux points changent tout : à quel moment le siège est choisi, et à quel moment les billets naissent.": {
    "de": "Sie unterscheiden sich in zwei Punkten, die entscheidend sind: wann der Platz gewählt wird und wann die Tickets entstehen.",
    "en": "They differ on just two points, but those points change everything: when the seat is chosen and when the tickets are issued."
  },
  "Un abonnement de série est nominatif et réserve un seul siège par représentation. Si une personne achète deux abonnements, chacun a son titulaire, sa place et sa carte. Le solde d’un carnet ne peut jamais devenir négatif : c’est garanti en base.": {
    "de": "Ein Serienabonnement ist persönlich und reserviert pro Vorstellung genau einen Platz. Kauft eine Person zwei Abonnements, hat jedes seine eigene Inhaberin oder seinen eigenen Inhaber, seinen Platz und seine Karte. Das Guthaben eines Eintrittsbuchs kann nie negativ werden: Das garantiert die Datenbank.",
    "en": "A series subscription is personal and reserves one seat per performance. If someone buys two subscriptions, each has its own holder, seat and card. An admission-book balance can never become negative: the database guarantees it."
  },
  "Chaque formule accepte un": {
    "de": "Jedes Abonnement kann eine",
    "en": "Each pass supports a"
  },
  "quota": {
    "de": "Quote",
    "en": "quota"
  },
  "(cent Série Mardi et pas une de plus) et des": {
    "de": "(hundert Dienstagsserien, keine mehr) und",
    "en": "(one hundred Tuesday Series passes, no more) and"
  },
  "zones imposées": {
    "de": "feste Zonen",
    "en": "restricted zones"
  },
  ", pour qu’un abonnement au parterre ne parte pas au balcon. Les": {
    "de": "haben, damit ein Parkettabonnement nicht auf dem Balkon landet. Die",
    "en": "so a stalls subscription cannot end up in the balcony. The"
  },
  "chèques culture": {
    "de": "Kulturgutscheine",
    "en": "culture vouchers"
  },
  "se déduisent par type, et la grille tarifaire d’une saison se": {
    "de": "werden nach Art abgezogen; die Preismatrix einer Saison lässt sich",
    "en": "are deducted by type, and a season’s price matrix can be"
  },
  "recopie sur la suivante": {
    "de": "in die nächste kopieren",
    "en": "copied to the next"
  },
  ": on repart de l’an passé, on ajuste, on ne ressaisit pas.": {
    "de": ": Sie übernehmen das Vorjahr und passen an, statt alles neu einzugeben.",
    "en": ": start from last year, adjust, and avoid re-entering everything."
  },
  "Deux personnes ne peuvent pas avoir le même fauteuil": {
    "de": "Zwei Personen können nicht denselben Sitzplatz haben",
    "en": "Two people cannot have the same seat"
  },
  "Un siège ne porte qu’un seul billet valide par représentation. La contrainte est posée dans la base de données. Quel que soit le chemin (campagne, guichet, carnet, boutique), la seconde opération échoue avec un message qui désigne le siège et la représentation en conflit. La génération des billets d’une série suit la même discipline : soit tous les billets de l’abonné naissent, soit aucun.": {
    "de": "Pro Vorstellung kann ein Platz nur ein gültiges Ticket haben. Diese Bedingung steht in der Datenbank. Ob Kampagne, Kasse, Guthabenkarte oder Shop: Der zweite Vorgang scheitert mit einer Meldung, die Platz und Vorstellung nennt. Für eine Serie gilt dasselbe: Entweder entstehen alle Tickets der abonnierenden Person oder keines.",
    "en": "A seat can have only one valid ticket per performance, enforced by the database. Whatever the route—campaign, box office, admission book or shop—the second operation fails with a message identifying the seat and performance. A series follows the same rule: either all of the subscriber’s tickets are created, or none."
  },
  "Aucun prix improvisé": {
    "de": "Keine improvisierten Preise",
    "en": "No improvised prices"
  },
  "Si un tarif manque dans la matrice, par exemple le tarif enfant au balcon pour un spectacle, la vente est bloquée avec un message explicite plutôt que facturée à 0 franc en silence. Une place gratuite doit être une invitation assumée, jamais un trou dans une grille.": {
    "de": "Fehlt ein Preis, etwa der Kindertarif auf dem Balkon, wird der Verkauf mit einer klaren Meldung blockiert, statt stillschweigend null Franken zu verrechnen. Ein Gratisplatz muss eine bewusste Einladung sein, nie eine Lücke in der Matrix.",
    "en": "If a price is missing, such as a child’s balcony price for a show, the sale is blocked with an explicit message instead of silently charging zero. A free seat must be a deliberate invitation, never a hole in the price matrix."
  },
  "Rien ne disparaît": {
    "de": "Nichts verschwindet",
    "en": "Nothing disappears"
  },
  "Une erreur de rang s’annule : le siège redevient disponible immédiatement, et le billet annulé reste dans l’historique avec son motif, son auteur et son heure. La structure du plan se fige dès le premier billet de la saison, si bien que plus personne ne peut supprimer le rang F en cours d’exploitation. Un journal d’audit inaltérable garde la trace de qui a fait quoi.": {
    "de": "Ein falscher Platz lässt sich stornieren: Er wird sofort frei, während das stornierte Ticket mit Grund, Person und Zeitpunkt im Verlauf bleibt. Die Planstruktur wird mit dem ersten Saisonticket gesperrt, damit niemand während des Betriebs Reihe F löscht. Ein unveränderbares Auditprotokoll hält fest, wer was getan hat.",
    "en": "A wrong seat can be cancelled: it becomes available immediately, while the cancelled ticket stays in the history with its reason, author and time. The plan’s structure locks at the first ticket of the season, so nobody can delete row F during operations. An immutable audit log records who did what."
  },
  "Un plan B écrit à l’avance": {
    "de": "Ein vorab festgelegter Plan B",
    "en": "A plan B written in advance"
  },
  "Le contrôle d’accès s’appuie sur le réseau, qui est ce qui garantit qu’un même billet ne passe pas à deux portes. Le repli est assumé et documenté : la liste d’émargement imprimée avant l’ouverture des portes, avec noms, sièges et origine des places. L’imprimer fait partie du rituel d’avant-scène, comme allumer les projecteurs.": {
    "de": "Die Einlasskontrolle nutzt das Netzwerk, um dasselbe Ticket nicht an zwei Türen einzulassen. Der dokumentierte Rückfallplan ist die vor Türöffnung gedruckte Einlassliste mit Namen, Plätzen und Herkunft der Tickets. Ihr Ausdruck gehört zur Vorbereitung wie das Einschalten der Scheinwerfer.",
    "en": "Admission checks rely on the network to prevent the same ticket being accepted at two doors. The documented fallback is an attendance list printed before doors open, showing names, seats and ticket origins. Printing it is part of the pre-show routine, like turning on the lights."
  },
  "Ce qui doit tenir un soir de première": {
    "de": "Was am Premierenabend halten muss",
    "en": "What must hold up on opening night"
  },
  "Quatre garanties": {
    "de": "Vier Garantien",
    "en": "Four guarantees"
  },
  "Nous n’encaissons pas directement, et c’est un parti pris.": {
    "de": "Wir kassieren nicht direkt – eine bewusste Entscheidung.",
    "en": "We do not collect payments directly, by design."
  },
  "Le public réserve, le système peut émettre une facture QR suisse et vous encaissez par virement sur votre propre IBAN : les montants ne transitent jamais par nous. Avec la facture QR, vous évitez les frais d’un prestataire de paiement.": {
    "de": "Das Publikum bucht, das System kann eine Schweizer QR-Rechnung ausstellen, und Sie erhalten die Überweisung auf Ihre eigene IBAN. Das Geld läuft nie über uns. Mit der QR-Rechnung vermeiden Sie die Gebühren eines Zahlungsanbieters.",
    "en": "The audience books, the system can issue a Swiss QR-bill, and you receive the transfer into your own account. Funds never pass through us. With a QR-bill, you avoid payment provider fees."
  },
  "Le paiement par carte via Stripe peut être activé avec le compte propre à votre théâtre": {
    "de": "Kartenzahlung über Stripe kann mit dem eigenen Konto Ihres Theaters aktiviert werden",
    "en": "Card payment through Stripe can be enabled with your theatre’s own account"
  },
  ". Sans configuration Stripe, la carte n’est pas proposée au public. Les frais Stripe relèvent de votre contrat ; ILYGO ne prélève aucun pourcentage sur vos recettes. Les autres prestataires demandent une intégration spécifique.": {
    "de": ". Ohne Stripe-Konfiguration wird Kartenzahlung dem Publikum nicht angeboten. Stripe-Gebühren richten sich nach Ihrem Vertrag; ILYGO erhebt keinen Prozentsatz auf Ihre Einnahmen. Andere Anbieter benötigen eine gesonderte Integration.",
    "en": ". Without Stripe configuration, card payment is not offered to the public. Stripe fees depend on your contract; ILYGO takes no percentage of your revenue. Other providers require a separate integration."
  },
  "Le contrôle hors ligne ne garantit plus les doublons entre appareils.": {
    "de": "Offline lassen sich doppelte Eintritte zwischen Geräten nicht mehr verhindern.",
    "en": "Offline checks cannot prevent duplicates across devices."
  },
  "En ligne, le contrôle d’accès garantit qu’un même billet ne passe pas à deux portes. Le mode hors ligne existe, il se prépare avant la soirée et il affiche en permanence l’heure de sa dernière synchronisation. Mais une fois activé,": {
    "de": "Online verhindert die Einlasskontrolle, dass ein Ticket an zwei Türen genutzt wird. Der Offlinemodus wird vor dem Abend vorbereitet und zeigt stets die letzte Synchronisierung. Sobald er aktiv ist,",
    "en": "Online admission checks prevent one ticket from passing through two doors. Offline mode is prepared before the event and always displays the last synchronisation time. Once active,"
  },
  "la détection des doublons redevient locale à chaque appareil": {
    "de": "werden doppelte Eintritte nur noch auf dem jeweiligen Gerät erkannt",
    "en": "duplicate detection becomes local to each device"
  },
  ". Deux contrôleurs à deux portes peuvent admettre le même billet sans le savoir. La liste d’émargement imprimée avant l’ouverture reste le filet, dans tous les cas.": {
    "de": ". Zwei Kontrollen an zwei Türen können unwissentlich dasselbe Ticket akzeptieren. Die vor Türöffnung gedruckte Einlassliste bleibt in jedem Fall das Sicherheitsnetz.",
    "en": ". Two staff members at different doors may unknowingly admit the same ticket. The attendance list printed before doors open remains the fallback in every case."
  },
  "Le produit est fait pour des salles jusqu’à environ cinq cents places.": {
    "de": "Das Produkt ist für Säle mit ungefähr bis zu fünfhundert Plätzen ausgelegt.",
    "en": "The product is designed for venues of roughly up to five hundred seats."
  },
  "C’est la taille pour laquelle il a été conçu et mesuré : jusqu’à cinq cents fauteuils sur un plan, et une dizaine de personnes qui travaillent en même temps au guichet un soir d’affluence. Au-delà, parlons-en avant que vous ne vous engagiez : nous préférons vous le dire maintenant plutôt que de vous vendre un logiciel qui rame le soir de la première.": {
    "de": "Für diese Grösse wurde es entwickelt und gemessen: bis zu fünfhundert Plätze im Plan und etwa zehn gleichzeitig arbeitende Kassenmitarbeitende an einem vollen Abend. Bei grösseren Häusern sprechen wir vor Vertragsabschluss darüber, statt Ihnen Software zu verkaufen, die an der Premiere langsam wird.",
    "en": "That is the scale it was designed and measured for: up to five hundred seats on a plan and around ten people working at the box office at the same time on a busy night. For larger venues, let’s discuss it before you commit; we would rather say so now than sell software that slows down on opening night."
  },
  "Ni place de marché, ni distribution.": {
    "de": "Weder Marktplatz noch Vertrieb.",
    "en": "Neither a marketplace nor a distribution service."
  },
  "Nous outillons": {
    "de": "Wir statten",
    "en": "We equip"
  },
  "votre": {
    "de": "Ihr",
    "en": "your"
  },
  "salle ; nous ne vous apportons pas de public. Un théâtre qui compte sur un revendeur pour toucher au-delà de ses propres spectateurs gardera ce revendeur en parallèle, et il a raison de le garder. Nous ne faisons non plus ni marketing, ni gestion de relation client, ni infolettre, ni revente entre particuliers.": {
    "de": "Haus aus; wir bringen Ihnen kein Publikum. Wer für zusätzliche Reichweite einen Wiederverkäufer braucht, behält ihn zu Recht parallel. Wir bieten weder Marketing, CRM, Newsletter noch privaten Ticketweiterverkauf.",
    "en": "venue; we do not bring you an audience. A theatre relying on a reseller to reach beyond its own audience should keep that reseller alongside us. We also provide no marketing, CRM, newsletters or peer-to-peer resale."
  },
  "Ce que votre équipe continuera de décider elle-même.": {
    "de": "Was Ihr Team weiterhin selbst entscheidet.",
    "en": "What your team will continue to decide."
  },
  "Aucun rapprochement bancaire automatique": {
    "de": "Kein automatischer Bankabgleich",
    "en": "No automatic bank reconciliation"
  },
  ", ni pour un règlement par facture, ni pour un encaissement en espèces au guichet : c’est vous qui saisissez l’encaissement, quand le virement arrive ou quand la caisse est comptée.": {
    "de": ", weder für Rechnungszahlungen noch für Bargeld an der Kasse: Sie erfassen den Eingang nach der Überweisung oder dem Kassenabschluss.",
    "en": ", whether payment is by invoice or cash at the box office: you record it when the transfer arrives or the till is counted."
  },
  "Aucune relance automatique": {
    "de": "Keine automatischen Zahlungserinnerungen",
    "en": "No automatic reminders"
  },
  ": le logiciel vous dit qui doit combien et depuis quand, un humain choisit les destinataires et déclenche l’envoi. Aucun échange de places en libre-service par le spectateur : l’administration peut déplacer une place, le public non. Aucun remboursement automatisé : cela reste un geste humain, saisi avec son motif et son auteur.": {
    "de": ": Die Software zeigt offene Beträge und Alter; ein Mensch wählt Empfänger und Versandzeitpunkt. Kein selbstständiger Platztausch durch das Publikum: Die Verwaltung kann umplatzieren, das Publikum nicht. Keine automatischen Rückerstattungen: Sie bleiben ein menschlicher Vorgang mit Grund und verantwortlicher Person.",
    "en": ": the software shows who owes how much and since when; a person selects recipients and sends. No self-service seat exchanges by customers: administrators can move a seat, the public cannot. No automated refunds: those remain a human action, recorded with a reason and author."
  },
  "Dit ici plutôt qu’en démonstration": {
    "de": "Hier gesagt, nicht erst in der Vorführung",
    "en": "Said here, not left for the demo"
  },
  "Ce que ce logiciel ne fait pas": {
    "de": "Was diese Software nicht leistet",
    "en": "What this software does not do"
  },
  "Cette liste est plus courte qu’il y a six mois, et elle continuera de raccourcir. Ce qui n’en sortira pas, c’est le premier point :": {
    "de": "Diese Liste ist kürzer als vor sechs Monaten und wird weiter schrumpfen. Ein Punkt bleibt:",
    "en": "This list is shorter than it was six months ago and will keep shrinking. Its first point will remain:"
  },
  "nous ne toucherons jamais à votre argent.": {
    "de": "Wir werden Ihr Geld niemals anfassen.",
    "en": "we will never touch your money."
  },
  "Configurer la salle": {
    "de": "Den Saal einrichten",
    "en": "Configure the venue"
  },
  "Préparer la saison": {
    "de": "Die Saison vorbereiten",
    "en": "Prepare the season"
  },
  "Mener la campagne d’abonnement": {
    "de": "Die Abonnementkampagne führen",
    "en": "Run the subscription campaign"
  },
  "Ouvrir la boutique en ligne": {
    "de": "Den Onlineshop öffnen",
    "en": "Open the online shop"
  },
  "Contrôler à l’entrée": {
    "de": "Den Einlass kontrollieren",
    "en": "Check admission"
  },
  "Suivre l’état des commandes": {
    "de": "Bestellungen verfolgen",
    "en": "Track orders"
  },
  "Suite de billetterie pour salles de spectacle et événements": {
    "de": "Ticketing für Veranstaltungsorte und Events",
    "en": "Ticketing suite for venues and events"
  },
  "Toute votre billetterie,": {
    "de": "Ihr gesamtes Ticketing,",
    "en": "All your ticketing,"
  },
  "campagne d’abonnement comprise.": {
    "de": "inklusive Abonnementkampagne.",
    "en": "including the season-pass campaign."
  },
  "Plan de salle et places numérotées, guichet, boutique en ligne, facturation, contrôle d’accès, tableaux de bord, et la gestion des abonnements.": {
    "de": "Saalplan und nummerierte Plätze, Kasse, Onlineshop, Rechnungen, Einlasskontrolle, Dashboards und Abonnementverwaltung.",
    "en": "Seating plans and numbered seats, box office, online shop, invoicing, admission checks, dashboards and subscription management."
  },
  "Édité en Suisse, à l’échelle qui est la vôtre : celle d’une salle qui monte sa saison, ou d’une équipe qui monte une soirée. Assez complet pour tenir votre guichet toute l’année, sans être taillé pour les tournées internationales. Et un prix au siège vendu, sans commission sur vos recettes.": {
    "de": "In der Schweiz entwickelt, in Ihrer Grössenordnung: für ein Haus, das seine Saison plant, oder ein Team, das einen Abend organisiert. Vollständig genug für Ihre ganzjährige Kasse, ohne auf internationale Tourneen zugeschnitten zu sein. Und ein Preis pro verkauftem Sitz, ohne Provision auf Ihre Einnahmen.",
    "en": "Published in Switzerland, at your scale: a venue planning its season or a team organising an evening. Complete enough to run your box office all year, without being built for international tours. And a price per seat sold, with no commission on your revenue."
  },
  "Essayer trente jours": {
    "de": "Dreissig Tage testen",
    "en": "Try it for thirty days"
  },
  "Voir la documentation": {
    "de": "Dokumentation ansehen",
    "en": "View the documentation"
  },
  "Le tarif, tout de suite": {
    "de": "Direkt zu den Preisen",
    "en": "Straight to pricing"
  },
  "Trente jours d’essai, sans engagement : aucune carte bancaire n’est demandée, et l’essai ne devient un abonnement que si vous le décidez.": {
    "de": "Dreissig Tage unverbindlich testen: ohne Kreditkarte. Die Testphase wird nur dann zum Abonnement, wenn Sie es entscheiden.",
    "en": "Thirty days to try it, without commitment: no credit card required. The trial becomes a subscription only if you decide."
  },
  "Les six étapes d’une année": {
    "de": "Die sechs Schritte eines Jahres",
    "en": "The six stages of a year"
  },
  "Six étapes, une année": {
    "de": "Sechs Schritte, ein Jahr",
    "en": "Six stages, one year"
  },
  "Voici ce que vous traversez avec le logiciel, dans l’ordre où votre saison l’amène.": {
    "de": "So begleitet Sie die Software durch Ihre Saison, in der tatsächlichen Reihenfolge.",
    "en": "Here is how the software accompanies your season, in the order it happens."
  },
  "Entre deux saisons": {
    "de": "Zwischen zwei Saisons",
    "en": "Between seasons"
  },
  "L’abonné réserve ses places et retrouve ses billets": {
    "de": "Abonnenten buchen Plätze und finden ihre Tickets wieder",
    "en": "Subscribers book seats and find their tickets"
  },
  "L’espace abonné se consulte sans mot de passe : on saisit son adresse, on reçoit un lien valable quinze minutes et à usage unique, on reste connecté trente jours sur l’appareil. Le bon compromis pour un public qui s’y rend trois fois par an.": {
    "de": "Das Abonnentenportal braucht kein Passwort: Adresse eingeben, einen fünfzehn Minuten gültigen Einmallink erhalten, auf dem Gerät dreissig Tage angemeldet bleiben. Ein guter Kompromiss für ein Publikum, das dreimal jährlich vorbeischaut.",
    "en": "The subscriber portal needs no password: enter an email address, receive a single-use link valid for fifteen minutes, and stay signed in on the device for thirty days. A practical balance for people visiting three times a year."
  },
  "Sa saison en cours :": {
    "de": "Die laufende Saison:",
    "en": "Their current season:"
  },
  "formule, sièges, prochaines dates, montant réellement dû": {
    "de": "Abonnement, Plätze, nächste Termine und tatsächlich offener Betrag",
    "en": "pass, seats, upcoming dates and the actual amount due"
  },
  ", ou bien le nombre de spectacles restants, ou bien le solde du carnet. Et ses documents, carte et billets, re-téléchargeables à volonté.": {
    "de": ", verbleibende Veranstaltungen oder Restguthaben. Dazu Karte und Tickets, beliebig oft herunterladbar.",
    "en": ", or the number of shows remaining, or their admission-book balance. Plus their card and tickets, downloadable as often as needed."
  },
  "Avec une formule au choix ou un carnet, il réserve une date et choisit ses places sur le plan de salle. Pour un carnet, il choisit une catégorie autorisée pour chaque billet et voit les entrées décomptées avant de confirmer.": {
    "de": "Mit einer Wahlformel oder einer Eintrittskarte bucht er einen Termin und wählt seine Plätze auf dem Saalplan. Bei einer Eintrittskarte wählt er für jedes Ticket eine zugelassene Kategorie und sieht vor der Bestätigung, wie viele Eintritte abgezogen werden.",
    "en": "With a flexible pass or admission book, subscribers book a date and choose seats on the seating plan. For an admission book, they choose an allowed category for each ticket and see the admissions to be deducted before confirming."
  },
  "Pour corriger ses coordonnées ou demander un changement particulier,": {
    "de": "Für Korrekturen der Kontaktdaten oder besondere Änderungswünsche",
    "en": "To correct contact details or request a special change,"
  },
  "l’abonné contacte votre équipe": {
    "de": "wendet sich der Abonnent an Ihr Team",
    "en": "the subscriber contacts your team"
  },
  "avec la référence de son dossier.": {
    "de": "mit der Referenz seines Dossiers.",
    "en": "with the reference for their booking."
  },
  "Essayer, tout de suite": {
    "de": "Sofort ausprobieren",
    "en": "Try it now"
  },
  "Nous préparons votre théâtre complet en 3 à 5 minutes : une saison déjà programmée, des abonnés et une campagne de réabonnement en cours. Le lien et vos identifiants arrivent par courriel. Pendant trente jours, tout est ouvert.": {
    "de": "Wir bereiten Ihr vollständiges Theater in 3 bis 5 Minuten vor: eine geplante Saison, Abonnenten und eine laufende Verlängerungskampagne. Den Link und Ihre Zugangsdaten erhalten Sie per E-Mail. Dreissig Tage lang steht alles offen.",
    "en": "We prepare your complete theatre in 3 to 5 minutes: a programmed season, subscribers and a renewal campaign in progress. Your link and login details arrive by email. Everything is open for thirty days."
  },
  "Ouvrir une démonstration": {
    "de": "Demo öffnen",
    "en": "Open a demo"
  },
  "Lire le manuel d’abord": {
    "de": "Zuerst das Handbuch lesen",
    "en": "Read the manual first"
  },
  "La documentation complète est publique, sans compte à créer : trente-neuf pages rangées par métier (administration, guichet, contrôle d’accès, direction, spectateurs, organisateur d’événement) et cent trente pièges concrets, du tarif manquant qui bloque une vente au panier qui expire pendant la saisie des coordonnées.": {
    "de": "Die gesamte Dokumentation ist ohne Konto öffentlich: neununddreissig Seiten nach Rollen geordnet (Verwaltung, Kasse, Einlass, Leitung, Publikum, Veranstalter) und hundertdreissig konkrete Stolperfallen, vom fehlenden Preis bis zum Warenkorb, der während der Adresseingabe ausläuft.",
    "en": "The complete documentation is public, with no account required: thirty-nine pages organised by role—administration, box office, admission, management, audience and event organiser—and one hundred and thirty practical pitfalls, from a missing price blocking a sale to a basket expiring during checkout."
  },
  "Ouvrir la documentation": {
    "de": "Dokumentation öffnen",
    "en": "Open the documentation"
  },
  "En parler d’abord": {
    "de": "Zuerst darüber sprechen",
    "en": "Talk first"
  },
  "Dites-nous votre jauge, vos formules et ce qui vous prend le plus de temps aujourd’hui. Nous répondons avec un prix et un avis franc, y compris quand ce logiciel n’est pas ce qu’il vous faut.": {
    "de": "Nennen Sie uns Kapazität, Abonnements und Ihre grössten Zeitfresser. Wir antworten mit einem Preis und einer ehrlichen Einschätzung, auch wenn diese Software nicht zu Ihnen passt.",
    "en": "Tell us your capacity, pass types and what takes most of your time today. We reply with a price and an honest opinion, including when this software is not right for you."
  },
  "Écrire à l’éditeur": {
    "de": "Dem Herausgeber schreiben",
    "en": "Contact the publisher"
  },
  "Et maintenant": {
    "de": "Und jetzt",
    "en": "What next"
  },
  "Trois façons d’aller plus loin": {
    "de": "Drei nächste Schritte",
    "en": "Three ways forward"
  },
  "L’essai ne demande aucune carte bancaire : nous n’encaissons rien, nous n’avons donc rien à vous demander. À son terme, votre théâtre de démonstration s’efface ou devient le vôtre.": {
    "de": "Für den Test brauchen Sie keine Kreditkarte: Wir ziehen nichts ein. Am Ende wird Ihr Demotheater gelöscht oder zu Ihrem eigenen.",
    "en": "The trial requires no credit card: we collect no payment. At its end, your demo theatre is deleted or becomes your own."
  },
  "Le siège, sur le plan de la salle": {
    "de": "Der Platz im Saalplan",
    "en": "The seat on the seating plan"
  },
  "Vendre une place au guichet : deux gestes": {
    "de": "Einen Platz an der Kasse verkaufen: zwei Schritte",
    "en": "Sell a seat at the box office in two actions"
  },
  "Le siège sur le plan. Encaisser. Le plein tarif s’applique d’office ; un tarif réduit ajoute un clic. Ctrl + Entrée encaisse sans lâcher le clavier, et la représentation du jour est déjà sélectionnée.": {
    "de": "Platz im Plan auswählen. Kassieren. Der Vollpreis gilt automatisch; eine Ermässigung braucht einen weiteren Klick. Strg + Eingabe kassiert per Tastatur, und die heutige Vorstellung ist bereits ausgewählt.",
    "en": "Select the seat on the plan. Take payment. Full price applies by default; a reduced price adds one click. Ctrl + Enter completes payment without leaving the keyboard, and today’s performance is already selected."
  },
  "Ouvrir votre théâtre : trois champs": {
    "de": "Ihr Theater eröffnen: drei Felder",
    "en": "Open your theatre: three fields"
  },
  "Le nom de votre théâtre, votre adresse électronique, et l’identifiant qui deviendra votre adresse, que nous vous proposons déjà rempli. C’est tout ce qu’il faut pour que votre théâtre existe.": {
    "de": "Der Name Ihres Theaters, Ihre E-Mail-Adresse und die bereits vorgeschlagene Kennung für Ihre Webadresse. Mehr braucht es nicht, damit Ihr Theater existiert.",
    "en": "Your theatre’s name, your email address and the suggested identifier that becomes your web address. That is all it takes to create your theatre."
  },
  "La campagne : quatre étapes numérotées, dans un seul menu": {
    "de": "Die Kampagne: vier nummerierte Schritte in einem Menü",
    "en": "The campaign: four numbered steps in one menu"
  },
  "Correspondance des formules, génération des propositions, traitement des bulletins, ouverture des phases. Numérotées, dans l’ordre, dans un seul menu. Le tableau de bord n’est pas une étape : c’est le point de retour.": {
    "de": "Abonnements zuordnen, Vorschläge erstellen, Antwortformulare bearbeiten, Phasen öffnen. Nummeriert und geordnet in einem Menü. Das Dashboard ist kein Schritt, sondern Ihr Ausgangspunkt.",
    "en": "Match passes, generate proposals, process renewal forms, open phases. Numbered, in order, in one menu. The dashboard is not a step: it is your point of return."
  },
  "Aucun logiciel à installer, nulle part": {
    "de": "Nirgends Software installieren",
    "en": "No software to install anywhere"
  },
  "Le back-office, le guichet, la boutique et le contrôle d’accès sont quatre pages web du même site. Rien à télécharger, rien à mettre à jour, rien à faire installer par quelqu’un. Le contrôle d’entrée tourne sur le téléphone de vos bénévoles, avec une session de douze heures pour ne pas se reconnecter à l’entracte.": {
    "de": "Verwaltung, Kasse, Shop und Einlasskontrolle sind vier Webseiten desselben Auftritts. Keine Downloads, Updates oder Installationen. Die Einlasskontrolle läuft auf den Telefonen Ihrer Freiwilligen mit einer zwölfstündigen Sitzung, damit in der Pause keine neue Anmeldung nötig ist.",
    "en": "Back office, box office, shop and admission checks are four web pages on the same site. Nothing to download, update or install. Admission checks run on volunteers’ phones, with a twelve-hour session to avoid logging in again at the interval."
  },
  "Aucun compte à créer, ni pour acheter, ni pour consulter": {
    "de": "Kein Konto zum Kaufen oder Nachsehen",
    "en": "No account needed to buy or view"
  },
  "Votre public n’a pas de mot de passe à retenir : il choisit sa place, laisse son nom et son adresse, et repart avec ses billets. Vos abonnés entrent dans leur espace par un lien reçu par courriel, valable quinze minutes. Un mot de passe oublié n’a jamais coûté une vente chez nous, puisqu’il n’y en a pas.": {
    "de": "Ihr Publikum braucht kein Passwort: Platz wählen, Name und Adresse angeben, Tickets erhalten. Abonnenten nutzen einen fünfzehn Minuten gültigen E-Mail-Link. Ein vergessenes Passwort hat hier noch keinen Verkauf verhindert, weil keines nötig ist.",
    "en": "Your audience has no password to remember: choose a seat, leave a name and email, receive the tickets. Subscribers use an emailed link valid for fifteen minutes. Forgotten passwords have never cost us a sale, because there are none."
  },
  "Aucun geste irréversible sans ses conséquences chiffrées": {
    "de": "Keine unumkehrbare Aktion ohne bezifferte Folgen",
    "en": "No irreversible action without quantified consequences"
  },
  "Avant chaque geste sans retour, l’écran affiche ce qu’il va se passer, en chiffres : « 37 propositions encore en attente vont expirer et libérer 61 sièges. » Vous confirmez ensuite, ou pas.": {
    "de": "Vor jedem endgültigen Schritt zeigt das System die Folgen in Zahlen: «37 offene Vorschläge laufen aus und geben 61 Plätze frei». Danach bestätigen Sie – oder nicht.",
    "en": "Before every irreversible action, the screen shows its consequences in numbers: “37 pending proposals will expire and release 61 seats”. Then you choose whether to confirm."
  },
  "Vous ne pouvez pas vous tromper de prix": {
    "de": "Kein versehentlich falscher Preis",
    "en": "You cannot accidentally charge the wrong price"
  },
  "Si le tarif enfant au balcon manque dans votre grille, la vente s’arrête avec le nom du tarif manquant, au lieu d’être facturée à zéro franc en silence. Une place gratuite doit être une invitation assumée, jamais un trou dans une grille.": {
    "de": "Fehlt der Kindertarif auf dem Balkon, stoppt der Verkauf mit dessen Namen, statt unbemerkt null Franken zu verrechnen. Ein Gratisplatz muss eine bewusste Einladung sein, nie eine Lücke in der Matrix.",
    "en": "If your child balcony price is missing, the sale stops and names the missing price instead of silently charging zero. A free seat must be a deliberate invitation, never a gap in the matrix."
  },
  "La prise en main": {
    "de": "Der Einstieg",
    "en": "Getting started"
  },
  "Deux gestes pour vendre une place": {
    "de": "Zwei Schritte für einen Platzverkauf",
    "en": "Two actions to sell a seat"
  },
  "Premier passage d’un billet valide. Le siège s’affiche.": {
    "de": "Erster Scan eines gültigen Tickets. Der Sitzplatz wird angezeigt.",
    "en": "First scan of a valid ticket. The seat is displayed."
  },
  "Déjà scanné": {
    "de": "Bereits gescannt",
    "en": "Already scanned"
  },
  "Avec l’heure du premier passage : doublon, capture d’écran partagée.": {
    "de": "Mit Zeitpunkt des ersten Einlasses: doppeltes Ticket oder geteilter Screenshot.",
    "en": "With the time of first admission: a duplicate or shared screenshot."
  },
  "Refusé": {
    "de": "Abgewiesen",
    "en": "Rejected"
  },
  "Billet annulé, autre représentation, carte révoquée : le motif est affiché.": {
    "de": "Storniertes Ticket, andere Vorstellung oder widerrufene Karte: Der Grund wird angezeigt.",
    "en": "Cancelled ticket, wrong performance or revoked card: the reason is displayed."
  },
  "Le soir, dans le hall": {
    "de": "Abends im Foyer",
    "en": "In the foyer on the night"
  },
  "Contrôler l’entrée avec le téléphone que vous avez déjà": {
    "de": "Einlasskontrolle mit dem Telefon, das Sie schon haben",
    "en": "Check admission with the phone you already have"
  },
  "Pas d’application à faire installer, pas de douchette à acheter, pas de bénévole à former : on ouvre une adresse, on choisit la représentation du soir, la caméra s’allume. Le verdict occupe l’écran entier et se lit à un mètre.": {
    "de": "Keine App installieren, keinen Scanner kaufen, keine Freiwilligen schulen: Webadresse öffnen, heutige Vorstellung wählen, Kamera starten. Das Ergebnis füllt den Bildschirm und ist auf einen Meter lesbar.",
    "en": "No app to install, scanner to buy or volunteer to train: open a web address, choose tonight’s performance, and the camera starts. The result fills the screen and is readable from a metre away."
  },
  "Le contrôle se fait sur un téléphone :": {
    "de": "Die Kontrolle läuft auf einem Telefon:",
    "en": "Checks run on a phone:"
  },
  "une page web, aucune installation": {
    "de": "eine Webseite, keine Installation",
    "en": "a web page, no installation"
  },
  ", session de 12 heures pour ne pas se reconnecter à l’entracte.": {
    "de": ", zwölfstündige Sitzung ohne erneute Anmeldung in der Pause.",
    "en": ", with a twelve-hour session so there is no need to log in again at the interval."
  },
  "Chaque abonnement donne droit à": {
    "de": "Jedes Abonnement berechtigt zu",
    "en": "Each subscription entitles its holder to"
  },
  "un billet par représentation": {
    "de": "einem Ticket pro Vorstellung",
    "en": "one ticket per performance"
  },
  ": chaque personne présente son propre billet, même si les abonnements ont été achetés ensemble.": {
    "de": ": Jede Person zeigt ihr eigenes Ticket vor, auch wenn die Abonnements zusammen gekauft wurden.",
    "en": ": each person presents their own ticket, even if the subscriptions were purchased together."
  },
  "QR illisible ou téléphone déchargé :": {
    "de": "QR unlesbar oder Telefon leer:",
    "en": "Unreadable QR code or flat phone battery:"
  },
  "recherche par nom": {
    "de": "Namenssuche",
    "en": "search by name"
  },
  "dans la liste du soir, admission manuelle journalisée.": {
    "de": "in der heutigen Liste, mit protokolliertem manuellem Einlass.",
    "en": "in tonight’s list, with logged manual admission."
  },
  "Un compteur suit la soirée :": {
    "de": "Ein Zähler begleitet den Abend:",
    "en": "A counter tracks the evening:"
  },
  "« 187 admis / 243 attendus »": {
    "de": "«187 eingelassen / 243 erwartet»",
    "en": "“187 admitted / 243 expected”"
  },
  "Un mode hors ligne existe": {
    "de": "Ein Offlinemodus ist vorhanden",
    "en": "An offline mode is available"
  },
  ": il se prépare avant la soirée, laisse le contrôle fonctionner sans réseau et affiche en permanence l’heure de sa dernière synchronisation. Une fois activé, il coûte une garantie :": {
    "de": ": Er wird vor dem Abend vorbereitet, funktioniert ohne Netzwerk und zeigt stets den Zeitpunkt der letzten Synchronisierung. Dabei entfällt eine Garantie:",
    "en": ": prepared before the event, it keeps admission checks running without a network and always shows the last synchronisation time. Using it gives up one guarantee:"
  },
  "laquelle, et pourquoi": {
    "de": "welche und warum",
    "en": "which one, and why"
  },
  ". Dans tous les cas, la liste d’émargement imprimée avant l’ouverture reste le filet.": {
    "de": ". Die vor Türöffnung gedruckte Einlassliste bleibt in jedem Fall das Sicherheitsnetz.",
    "en": ". In every case, the attendance list printed before doors open remains the fallback."
  },
  "Ce que votre saison coûterait": {
    "de": "Was Ihre Saison kosten würde",
    "en": "What your season would cost"
  },
  "Réglez votre salle, et le calcul se fait devant vous. Rien n’est envoyé nulle part.": {
    "de": "Stellen Sie Ihren Saal ein, und die Rechnung entsteht vor Ihren Augen. Nichts wird irgendwohin gesendet.",
    "en": "Set your venue, and the calculation happens in front of you. Nothing is sent anywhere."
  },
  "Jauge de la salle": {
    "de": "Platzzahl des Saals",
    "en": "Venue capacity"
  },
  "Représentations par saison": {
    "de": "Vorstellungen pro Saison",
    "en": "Performances per season"
  },
  "Remplissage moyen": {
    "de": "Durchschnittliche Auslastung",
    "en": "Average attendance"
  },
  "places": {
    "de": "Plätze",
    "en": "seats"
  },
  "sièges vendus": {
    "de": "verkaufte Sitze",
    "en": "seats sold"
  },
  "par siège": {
    "de": "pro Sitz",
    "en": "per seat"
  },
  "Position de votre tarif dans la fourchette du marché": {
    "de": "Position Ihres Preises in der Marktspanne",
    "en": "Where your price sits in the market range"
  },
  "Le logiciel de billetterie seul, sans l’encaissement et sans la mise en avant sur un agenda, se paie entre CHF 0.22 et CHF 1.02 par billet sur le marché suisse et romand. C’est la seule fourchette comparable à un tarif comme le nôtre : les pourcentages affichés par les plateformes qui encaissent achètent aussi le traitement de la carte et la promotion de vos dates, deux choses que nous ne vendons pas.": {
    "de": "Die Ticketing-Software allein, ohne Zahlungsabwicklung und ohne Platzierung in einem Veranstaltungskalender, kostet auf dem Schweizer und Westschweizer Markt zwischen CHF 0.22 und CHF 1.02 pro Ticket. Das ist die einzige Spanne, die mit einem Preis wie dem unseren vergleichbar ist: die Prozentsätze der Plattformen, die kassieren, bezahlen auch die Kartenabwicklung und die Bewerbung Ihrer Termine, zwei Dinge, die wir nicht verkaufen.",
    "en": "Ticketing software alone, without payment processing and without promotion in a listings agenda, costs between CHF 0.22 and CHF 1.02 per ticket on the Swiss and French-speaking Swiss market. It is the only range comparable to a price like ours: the percentages shown by the platforms that collect payment also buy card processing and the promotion of your dates, two things we do not sell."
  },
  "Un tarif au siège vendu, jamais un pourcentage de vos recettes": {
    "de": "Ein Preis pro verkauftem Sitz, nie ein Prozentsatz Ihrer Einnahmen",
    "en": "A price per seat sold, never a percentage of your revenue"
  },
  "Un siège vendu payant, c’est une place occupée par un spectateur qui l’a payée, pour une représentation donnée : un abonnement à dix spectacles compte dix sièges. Les invitations, les places offertes, les réimpressions au guichet et les sièges invendus ne comptent pas.": {
    "de": "Ein bezahlter verkaufter Sitz ist ein Platz, den ein Zuschauer bezahlt hat, für eine bestimmte Vorstellung: ein Abonnement für zehn Vorstellungen zählt zehn Sitze. Einladungen, Freiplätze, Nachdrucke an der Kasse und unverkaufte Sitze zählen nicht.",
    "en": "A paid seat sold is a seat taken by someone who paid for it, for a given performance: a subscription to ten shows counts ten seats. Invitations, complimentary seats, reprints at the counter and unsold seats do not count."
  },
  "1 à 3’000 sièges": {
    "de": "1 bis 3’000 Sitze",
    "en": "1 to 3’000 seats"
  },
  "3’001 à 8’000": {
    "de": "3’001 bis 8’000",
    "en": "3’001 to 8’000"
  },
  "8’001 à 15’000": {
    "de": "8’001 bis 15’000",
    "en": "8’001 to 15’000"
  },
  "dès 15’001": {
    "de": "ab 15’001",
    "en": "from 15’001"
  },
  "par siège vendu": {
    "de": "pro verkauftem Sitz",
    "en": "per seat sold"
  },
  "Le tarif s’applique par tranche : chaque siège est facturé au prix de la tranche dans laquelle il tombe. Aucun montant minimum, aucun abonnement, aucun frais d’ouverture : vous ne payez que ce que vous vendez.": {
    "de": "Der Preis gilt nach Stufen: jeder Sitz wird zum Preis der Stufe verrechnet, in die er fällt. Kein Mindestbetrag, kein Abonnement, keine Einrichtungsgebühr: Sie zahlen nur, was Sie verkaufen.",
    "en": "The price applies by band: each seat is billed at the price of the band it falls into. No minimum, no subscription, no set-up fee: you pay only for what you sell."
  },
  "Mise en service accompagnée": {
    "de": "Begleitete Inbetriebnahme",
    "en": "Assisted setup"
  },
  "Une journée entière sur site, chez vous : import de votre fichier d’abonnés, saisie complète de votre plan de salle, personnalisation de vos billets, de vos cartes d’abonné et de vos factures à vos couleurs, formation de votre équipe au guichet, mise en route de votre première campagne de réabonnement, et intégration de votre propre prestataire de paiement. La vérification ci-contre est comprise.": {
    "de": "Ein ganzer Tag bei Ihnen vor Ort: Import Ihrer Abonnentendatei, vollständige Erfassung Ihres Saalplans, Gestaltung Ihrer Tickets, Abonnementkarten und Rechnungen in Ihren Farben, Schulung Ihres Teams an der Kasse, Start Ihrer ersten Verlängerungskampagne und Anbindung Ihres eigenen Zahlungsdienstleisters. Die nebenstehende Überprüfung ist enthalten.",
    "en": "A full day on site, at your venue: importing your subscriber file, entering your seating plan in full, styling your tickets, subscriber cards and invoices in your colours, training your team at the counter, launching your first renewal campaign, and connecting your own payment provider. The review opposite is included."
  },
  "Vérification avant première campagne": {
    "de": "Überprüfung vor der ersten Kampagne",
    "en": "Review before the first campaign"
  },
  "CHF 600.– une fois": {
    "de": "CHF 600.– einmalig",
    "en": "CHF 600.– one-off"
  },
  "Une demi-journée en visioconférence pour vous accompagner et vérifier ce qui casse en silence, à savoir les trous dans la grille tarifaire, un plan mal saisi, un IBAN invalide, un domaine d’expédition des courriels non configuré. C’est aussi la prestation d’accompagnement pour un évènement ponctuel.": {
    "de": "Ein halber Tag per Videokonferenz, um Sie zu begleiten und unauffällige Fehler zu prüfen: Preislücken, ein falsch erfasster Saalplan, eine ungültige IBAN, eine nicht eingerichtete E-Mail-Absenderdomain. Es ist auch die Begleitleistung für eine Einzelveranstaltung.",
    "en": "Half a day by video call to guide you and check the silent failure points: gaps in pricing, an incorrectly entered plan, an invalid IBAN, an unconfigured email sending domain. It is also the guidance service for a one-off event."
  },
  "Toutes les fonctions du logiciel, sans module payant ni option débloquée à la carte.": {
    "de": "Alle Softwarefunktionen, ohne kostenpflichtige Module oder einzeln freizuschaltende Optionen.",
    "en": "All software functions, with no paid modules or individually unlocked options."
  },
  "Tous les postes de travail : administration, guichet, direction, bénévoles au scan.": {
    "de": "Alle Arbeitsplätze: Verwaltung, Kasse, Leitung und Freiwillige am Einlass.",
    "en": "Every workstation: administration, box office, management and volunteers at admission."
  },
  "Nous nous engageons à héberger vos données en Suisse, à les sauvegarder chaque jour et à éprouver la restauration.": {
    "de": "Wir verpflichten uns, Ihre Daten in der Schweiz zu hosten, täglich zu sichern und die Wiederherstellung zu prüfen.",
    "en": "We commit to hosting your data in Switzerland, backing it up daily and testing restoration."
  },
  "Les mises à jour et les nouvelles fonctions, au fil de l’eau.": {
    "de": "Laufende Updates und neue Funktionen.",
    "en": "Ongoing updates and new features."
  },
  "Les cartes d’abonné et les billets, sans compteur ni supplément.": {
    "de": "Abonnentenkarten und Tickets ohne Zähler oder Aufpreis.",
    "en": "Subscriber cards and tickets, without metering or extra charges."
  },
  "Le support par courriel et par téléphone, renforcé en mai-juin.": {
    "de": "Support per E-Mail und Telefon, verstärkt im Mai und Juni.",
    "en": "Email and telephone support, reinforced in May and June."
  },
  "Rien au spectateur : aucun frais ajouté au prix d’un billet.": {
    "de": "Keine Kosten für das Publikum: kein Aufschlag auf den Ticketpreis.",
    "en": "Nothing charged to the audience: no fees added to ticket prices."
  },
  "Les invitations, les places offertes, les réimpressions au guichet et les sièges invendus : ils ne comptent jamais dans votre décompte.": {
    "de": "Einladungen, Freiplätze, Nachdrucke an der Kasse und unverkaufte Sitze: sie zählen nie in Ihrer Abrechnung.",
    "en": "Invitations, complimentary seats, reprints at the counter and unsold seats: they never count in your statement."
  },
  "Aucun pourcentage de votre recette, ni aujourd’hui ni si un prestataire de paiement est branché plus tard. Ses frais resteront à votre propre contrat, sur votre propre IBAN.": {
    "de": "Kein Anteil an Ihren Einnahmen, weder heute noch bei späterer Anbindung eines Zahlungsdienstleisters. Dessen Gebühren bleiben in Ihrem eigenen Vertrag, auf Ihrer IBAN.",
    "en": "No percentage of your revenue, today or if a payment provider is connected later. Its fees remain under your own contract, with your own IBAN."
  },
  "Aucune commande de votre boutique en ligne n’est taxée : quel que soit le moyen de règlement, les montants ne transitent jamais par nous.": {
    "de": "Keine Gebühr pro Shopbestellung: Unabhängig vom Zahlungsmittel läuft das Geld niemals über uns.",
    "en": "No charge on any online-shop order: whatever the payment method, the funds never pass through us."
  },
  "Aucune pénalité de succès ni frais de sortie : vos données s’exportent en un clic, à tout moment.": {
    "de": "Keine Erfolgsaufschläge oder Austrittsgebühren: Ihre Daten sind jederzeit mit einem Klick exportierbar.",
    "en": "No success penalties or exit fees: export your data in one click at any time."
  },
  "Le tarif": {
    "de": "Der Preis",
    "en": "Pricing"
  },
  "Un forfait annuel, qui ne dépend pas de vos recettes": {
    "de": "Eine Jahrespauschale, unabhängig von Ihren Einnahmen",
    "en": "An annual flat fee, independent of your revenue"
  },
  "par an": {
    "de": "pro Jahr",
    "en": "per year"
  },
  "soit": {
    "de": "entspricht",
    "en": "equivalent to"
  },
  "Au-delà de 900 places : sur devis. Une limite anti-abus de 200 fois votre jauge s’applique, soit l’équivalent de 200 représentations à guichets fermés. Si vous deviez l’approcher, nous en reparlerions ; elle n’interrompt jamais une vente.": {
    "de": "Über 900 Plätze: auf Anfrage. Eine Missbrauchsgrenze von 200-mal Ihrer Kapazität entspricht 200 ausverkauften Vorstellungen. Sollten Sie sich ihr nähern, sprechen wir darüber; sie unterbricht niemals einen Verkauf.",
    "en": "Over 900 seats: on request. An anti-abuse limit of 200 times your capacity applies, equivalent to 200 sold-out performances. If you approach it, we discuss it; it never interrupts a sale."
  },
  "Ces deux prestations sont facultatives. Vous pouvez tout monter vous-même : c’est exactement ce que fait l’essai de trente jours.": {
    "de": "Beide Leistungen sind optional. Sie können alles selbst einrichten, genau wie im dreissigtägigen Test.",
    "en": "Both services are optional. You can set everything up yourself, exactly as in the thirty-day trial."
  },
  "Compris dans le forfait": {
    "de": "In der Pauschale enthalten",
    "en": "Included in the flat fee"
  },
  "Ce que nous ne facturerons jamais": {
    "de": "Was wir niemals verrechnen",
    "en": "What we will never charge"
  },
  "Ce que ça remplace": {
    "de": "Was es ersetzt",
    "en": "What it replaces"
  },
  "Pour une salle de 400 places qui vend environ 7’700 sièges sur la saison, notre tarif revient à": {
    "de": "Für einen Saal mit 400 Plätzen und rund 7’700 verkauften Sitzen pro Saison kostet unser Preis",
    "en": "For a 400-seat venue selling around 7’700 seats per season, our price works out at"
  },
  "par siège. Avec 400 abonnés, cela fait": {
    "de": "pro Sitz. Bei 400 Abonnenten sind das",
    "en": "per seat. With 400 subscribers, that is"
  },
  "par abonné et par an. Vos chiffres à vous donneront un autre résultat : la règle, elle, ne bouge pas.": {
    "de": "pro Abonnent und Jahr. Ihre Zahlen ergeben ein anderes Resultat; die Regel bleibt gleich.",
    "en": "per subscriber per year. Your figures will give a different result; the rule itself stays the same."
  },
  "Le prix du siège ne dépend jamais du prix du billet.": {
    "de": "Der Preis pro Sitz hängt nie vom Ticketpreis ab.",
    "en": "The price per seat never depends on the ticket price."
  },
  "Une billetterie facturée au pourcentage, elle, prélève quatre fois plus sur une place à 80 francs que sur une place à 20, et elle suit la croissance de vos ventes en ligne, si bien que c’est précisément l’année où tout va bien qu’elle dépasse la ligne prévue. Ici, vous payez un montant fixe par siège, connu d’avance, et rien sur votre recette.": {
    "de": "Prozentual verrechnetes Ticketing nimmt dagegen viermal so viel von einem Platz zu 80 Franken wie von einem zu 20, und es wächst mit Ihren Onlineverkäufen, sodass es die Budgetlinie gerade dann überschreitet, wenn alles gut läuft. Hier zahlen Sie einen festen, im Voraus bekannten Betrag pro Sitz und nichts von Ihren Einnahmen.",
    "en": "Percentage-based ticketing takes four times as much from an 80-franc seat as from a 20-franc one, and it follows the growth in your online sales, exceeding the planned line precisely in the year when everything goes well. Here you pay a fixed amount per seat, known in advance, and nothing on your revenue."
  },
  "Vous ne recevez qu’un seul appel de fonds dans l’année. L’acompte est calculé en juin sur 80 % du montant réel de la saison écoulée (pour une première saison, sur le volume que vous estimez), facturé à l’ouverture de saison par facture QR suisse, et le solde se régularise à la clôture sur le décompte des sièges vendus que votre propre back-office produit et que vous pouvez auditer. Dans les deux sens : une saison en retrait vous est remboursée. La hausse d’un acompte à l’autre": {
    "de": "Sie erhalten nur eine einzige Zahlungsaufforderung pro Jahr. Die Anzahlung wird im Juni auf 80 % des tatsächlichen Betrags der vergangenen Saison berechnet, bei einer ersten Saison auf dem von Ihnen geschätzten Volumen, zu Saisonbeginn per Schweizer QR-Rechnung verrechnet, und der Restbetrag wird zum Saisonschluss auf der Abrechnung der verkauften Sitze ausgeglichen, die Ihr eigenes Back-Office erstellt und die Sie prüfen können. In beide Richtungen: eine schwächere Saison wird Ihnen zurückerstattet. Der Anstieg von einer Anzahlung zur nächsten",
    "en": "You receive only one call for funds a year. The advance is calculated in June on 80 % of the previous season’s actual amount, or on the volume you estimate for a first season, invoiced at the opening of the season by Swiss QR invoice, and the balance is settled at the close on the count of seats sold that your own back office produces and that you can audit. Both ways: a weaker season is refunded to you. The increase from one advance to the next"
  },
  "ne peut pas dépasser 30 %": {
    "de": "darf 30 % nicht übersteigen",
    "en": "cannot exceed 30 %"
  },
  "Le contrat court sur douze mois et se reconduit tacitement sauf résiliation adressée": {
    "de": "Der Vertrag läuft zwölf Monate und verlängert sich stillschweigend, sofern keine Kündigung eingeht",
    "en": "The contract runs for twelve months and renews automatically unless cancelled"
  },
  "trois mois avant son échéance": {
    "de": "drei Monate vor Ablauf",
    "en": "three months before its end date"
  },
  "Le plan de la salle du Théâtre du Bourg-Neuf au guichet : 420 places en trois zones colorées, deux fauteuils sélectionnés en bordeaux, la catégorie de public choisie place par place, un total à encaisser de CHF 110.00 et le bouton Encaisser.": {
    "de": "Kassenplan des Théâtre du Bourg-Neuf: 420 Plätze in drei farbigen Zonen, zwei bordeauxrot ausgewählte Sitze, Publikumskategorie pro Platz, Gesamtbetrag CHF 110.00 und die Schaltfläche zum Kassieren.",
    "en": "The Théâtre du Bourg-Neuf seating plan at the box office: 420 seats in three coloured zones, two burgundy selections, audience category per seat, a CHF 110.00 total and the payment button."
  },
  "La vente au guichet. Le menu de gauche est le back-office entier : configuration, saison, campagne, guichet, suivi, régie.": {
    "de": "Kassenverkauf. Links das gesamte Backoffice: Konfiguration, Saison, Kampagne, Kasse, Auswertung und Regie.",
    "en": "Box-office sales. The left menu contains the full back office: configuration, season, campaign, sales, monitoring and operations."
  },
  "Le plan de la salle du Théâtre du Bourg-Neuf en pleine vente au guichet : Cyrano de Bergerac le mardi 12 octobre 2027, 415 places encore libres sur 420 réparties en trois zones colorées, deux fauteuils retenus en bordeaux, le tarif choisi place par place, un total à encaisser de CHF 110.00 et le bouton Encaisser.": {
    "de": "Laufender Kassenverkauf im Théâtre du Bourg-Neuf: Cyrano de Bergerac am Dienstag, 12. Oktober 2027, 415 von 420 Plätzen in drei Zonen frei, zwei bordeauxrote Reservierungen, Tarif pro Platz, CHF 110.00 Gesamtbetrag und Kassieren.",
    "en": "Box-office sales at Théâtre du Bourg-Neuf: Cyrano de Bergerac on Tuesday 12 October 2027, 415 of 420 seats available across three zones, two burgundy holds, a price per seat, a CHF 110.00 total and the payment button."
  },
  "La vente au guichet : le siège sur le plan, puis Encaisser.": {
    "de": "Kassenverkauf: Platz im Plan wählen, dann kassieren.",
    "en": "Box-office sales: select a seat on the plan, then take payment."
  },
  "Le catalogue d’une saison : quatorze spectacles et vingt-deux dates, chacun avec sa table de représentations datées, sa salle et son statut, et les actions modifier, supprimer, annuler.": {
    "de": "Saisonkatalog: vierzehn Veranstaltungen und zweiundzwanzig Termine mit Vorstellungstabelle, Saal, Status sowie Ändern, Löschen und Absagen.",
    "en": "A season catalogue: fourteen shows and twenty-two dates, each with its performance table, room, status and edit, delete and cancel actions."
  },
  "Une saison se monte spectacle par spectacle, date par date. Aucun fichier à préparer.": {
    "de": "Eine Saison entsteht Veranstaltung für Veranstaltung, Termin für Termin. Ohne vorbereitete Datei.",
    "en": "Build a season show by show, date by date. No file to prepare."
  },
  "Le plan de la salle vu par un spectateur : la scène en haut, les zones tarifaires en couleurs, deux fauteuils retenus en bordeaux, et à droite le détail des deux places à CHF 55.00 avec un sous-total de CHF 110.00, un compte à rebours de réservation et la légende des états de siège.": {
    "de": "Saalplan aus Publikumssicht: Bühne oben, farbige Preiszonen, zwei bordeauxrot reservierte Plätze. Rechts zwei Plätze zu CHF 55.00, Zwischensumme CHF 110.00, Reservierungs-Countdown und Zustandslegende.",
    "en": "The audience’s seating plan: stage at the top, coloured price zones and two burgundy holds. On the right, two CHF 55.00 seats, a CHF 110.00 subtotal, reservation countdown and seat-status legend."
  },
  "Le spectateur choisit son fauteuil sur le plan de votre salle, le même que voit votre guichet.": {
    "de": "Das Publikum wählt im selben Saalplan wie Ihre Kasse.",
    "en": "Customers choose seats on the same seating plan your box office uses."
  },
  "L’affiche de la saison 2027-2028 vue par un spectateur : la mention « aucun compte n’est nécessaire pour acheter », des filtres par spectacle et par date au format 12.10.2027, puis chaque spectacle avec ses dates, sa disponibilité et son prix d’appel.": {
    "de": "Saisonplakat 2027–2028 aus Publikumssicht: Kauf ohne Konto, Filter nach Veranstaltung und Datum im Format 12.10.2027, danach Termine, Verfügbarkeit und Einstiegspreis pro Veranstaltung.",
    "en": "The audience’s 2027–2028 season page: no account needed to buy, show and date filters in 12.10.2027 format, then each show’s dates, availability and starting price."
  },
  "Votre saison, à votre adresse, sans compte à créer.": {
    "de": "Ihre Saison unter Ihrer Adresse, ohne Kontoerstellung.",
    "en": "Your season, at your address, with no account to create."
  },
  "Le panier d’un spectateur : deux places nommées par leur spectacle, leur date, leur fauteuil et leur zone, un tarif modifiable ligne par ligne, le compte à rebours qui défend les sièges, le bouton « me laisser plus de temps », un total de CHF 110.00 et « passer à la commande ».": {
    "de": "Warenkorb: zwei Plätze mit Veranstaltung, Datum, Sitz und Zone, einzeln änderbarem Tarif, Reservierungs-Countdown, Zeitverlängerung, CHF 110.00 Gesamtbetrag und Weiter zur Bestellung.",
    "en": "A customer’s basket: two seats with show, date, seat and zone, individually editable prices, a reservation countdown, an extend-time button, a CHF 110.00 total and proceed to checkout."
  },
  "Le compte à rebours défend les sièges pendant la saisie. Le délai se prolonge une fois, et une seule.": {
    "de": "Der Countdown schützt die Plätze während der Eingabe. Eine einmalige Verlängerung ist möglich.",
    "en": "The countdown holds seats during checkout. It can be extended once, and only once."
  },
  "La fin du parcours d’achat : un récapitulatif à deux fauteuils, un montant à régler de CHF 110.00 au nom de l’acheteuse, les deux billets avec leur bouton de téléchargement PDF, la facture n° 1 avec sa référence structurée, et le bandeau vert « commande confirmée » qui annonce l’envoi des billets et de la facture par courriel.": {
    "de": "Kaufabschluss: Zusammenfassung mit zwei Sitzen, CHF 110.00 auf den Namen der Käuferin, zwei PDF-Downloads, Rechnung Nr. 1 mit strukturierter Referenz und eine grüne Bestellbestätigung mit Ankündigung des Ticket- und Rechnungsversands.",
    "en": "Checkout completion: two-seat summary, CHF 110.00 due in the buyer’s name, two PDF ticket downloads, invoice no. 1 with structured reference and a green order-confirmed banner announcing email delivery of tickets and invoice."
  },
  "La commande se termine ici. L’écran le dit lui-même : « une facture avec QR-code suisse a été émise ; c’est par elle que le règlement se fait aujourd’hui ».": {
    "de": "Hier endet die Bestellung. Der Bildschirm erklärt: Eine Schweizer QR-Rechnung wurde erstellt; darüber wird heute bezahlt.",
    "en": "The order ends here. The screen explains that a Swiss QR-bill has been issued and is how payment is made today."
  },
  "Le billet PDF occupe la moitié haute d’une page A4 : le Théâtre du Bourg-Neuf et la Grande salle en en-tête, Cyrano de Bergerac le 12.10.2027 à 20:00, le siège A2 au Parterre en catégorie 1 et CHF 55.00 à gauche, le QR de contrôle avec son code à droite, puis un pointillé de découpe sous le billet.": {
    "de": "Das PDF-Ticket belegt die obere Hälfte einer A4-Seite: Théâtre du Bourg-Neuf und Grande salle im Kopf, Cyrano de Bergerac am 12.10.2027 um 20 Uhr, Parkettplatz A2 in Kategorie 1 und CHF 55.00 links, Kontroll-QR mit Code rechts und eine Schnittlinie unter dem Ticket.",
    "en": "The PDF ticket fills the top half of an A4 page: Théâtre du Bourg-Neuf and Grande salle in the header, Cyrano de Bergerac on 12 October 2027 at 20:00, stalls seat A2 in category 1 and CHF 55.00 on the left, the admission QR and code on the right, and a cut line below."
  },
  "Le billet PDF actuel : détachable dans la moitié haute de la page A4.": {
    "de": "Das aktuelle PDF-Ticket: abtrennbar in der oberen Hälfte der A4-Seite.",
    "en": "The current PDF ticket: detachable from the top half of the A4 page."
  },
  "La facture QR suisse sur une page A4 : la facture détaillée en haut au nom de l’association du théâtre à 1867 Villaz-le-Lac, deux lignes de fauteuils, un total à payer de CHF 110.00, le QR-IBAN et sa référence à vingt-sept chiffres, puis le récépissé et la section paiement détachables avec le QR-code scannable.": {
    "de": "Schweizer QR-Rechnung auf A4: Rechnung an den Theaterverein in 1867 Villaz-le-Lac, zwei Sitzpositionen, CHF 110.00, QR-IBAN mit 27-stelliger Referenz sowie abtrennbarer Empfangsschein und Zahlteil mit scanbarem QR.",
    "en": "An A4 Swiss QR-bill: invoice in the theatre association’s name in 1867 Villaz-le-Lac, two seat lines, CHF 110.00 due, QR-IBAN with a 27-digit reference, and detachable receipt and payment section with a scannable QR code."
  },
  "La facture QR conforme à la norme suisse SIX, à votre nom et sur votre propre IBAN. Elle se paie depuis n’importe quelle application bancaire.": {
    "de": "QR-Rechnung nach Schweizer SIX-Standard, unter Ihrem Namen und mit Ihrer IBAN. Bezahlbar in jeder Banking-App.",
    "en": "A QR-bill compliant with the Swiss SIX standard, in your name and with your IBAN. Payable from any banking app."
  },
  "Le contrôle d’accès sur un téléphone tenu à la verticale : le verdict ADMIS occupe toute la largeur sur fond vert, le siège E9 s’affiche en très gros, suivis de la zone, du nom du porteur, de l’origine « abonnement · AVS/AI », de l’heure d’entrée, du compteur « 18 admis / 39 attendus » et du bouton « scanner le suivant ».": {
    "de": "Einlasskontrolle am hochkant gehaltenen Telefon: grosses grünes Einlassergebnis, Sitz E9, Zone, Name, Herkunft Abonnement AHV/IV, Einlasszeit, Zähler «18 eingelassen / 39 erwartet» und Nächstes Ticket scannen.",
    "en": "Admission check on a portrait phone: a full-width green admitted result, large seat E9, zone, holder’s name, subscription/senior origin, admission time, “18 admitted / 39 expected” counter and scan-next button."
  },
  "Le verdict se lit à un mètre, dans un hall, par quelqu’un qui n’a jamais reçu de formation.": {
    "de": "Das Ergebnis ist im Foyer auf einen Meter lesbar, auch ohne Schulung.",
    "en": "The result is readable from a metre away in a foyer, even without training."
  },
  "Le tableau de bord des revenus d’une saison : un chiffre d’affaires de CHF 11’779.00, CHF 9’914.00 encaissés et CHF 1’865.00 encore dus, puis la ventilation par formule d’abonnement (Série Mardi, Liberté 5, Carnet 10) et par spectacle.": {
    "de": "Saisonumsatz-Dashboard: CHF 11’779.00 Umsatz, CHF 9’914.00 bezahlt, CHF 1’865.00 offen, danach Aufteilung nach Abonnement und Veranstaltung.",
    "en": "Season revenue dashboard: CHF 11’779.00 revenue, CHF 9’914.00 paid and CHF 1’865.00 outstanding, followed by breakdowns by pass and show."
  },
  "Ce que voit la direction, en lecture seule : ce qui est vendu, ce qui est encaissé, ce qui reste dû.": {
    "de": "Die schreibgeschützte Sicht der Leitung: verkauft, bezahlt, noch offen.",
    "en": "Management’s read-only view: sold, paid and still outstanding."
  },
  "Le tableau de bord du remplissage : places offertes, vendues, d’abonnés, invitations, hors vente et taux d’occupation, puis le détail soirée par soirée avec son filtre et ses exports CSV.": {
    "de": "Auslastungs-Dashboard: angebotene, verkaufte und abonnierte Plätze, Einladungen, nicht verkäufliche Plätze und Auslastung. Danach Details pro Abend mit Filter und CSV-Export.",
    "en": "Occupancy dashboard: offered, sold and subscriber seats, invitations, unavailable seats and occupancy rate, followed by per-evening details with filtering and CSV exports."
  },
  "Le remplissage soirée par soirée, exportable en CSV. Les chiffres visibles ici sont ceux du jeu de démonstration, volontairement peu rempli.": {
    "de": "Auslastung pro Abend, als CSV exportierbar. Gezeigt werden die bewusst niedrig ausgelasteten Demodaten.",
    "en": "Occupancy per evening, exportable to CSV. The figures shown come from the deliberately lightly booked demo dataset."
  },
  "L’espace d’une abonnée ouvert par un simple lien reçu par courriel, sans mot de passe : « Bonjour Marie Dubuis », les onglets Ma saison, Mes documents et Mon historique, la carte d’abonné pour la formule « Série Mardi », saison 2026-2027, marquée Active, et la liste de ses billets retéléchargeables un par un.": {
    "de": "Abonnentenportal per E-Mail-Link ohne Passwort: Begrüssung von Marie Dubuis, Register für Saison, Dokumente und Verlauf, aktive Karte der Dienstagsserie 2026–2027 sowie einzeln erneut herunterladbare Tickets.",
    "en": "A subscriber portal opened through an emailed link without a password: a greeting for Marie Dubuis, season, documents and history tabs, an active Tuesday Series card for 2026–2027 and individually downloadable tickets."
  },
  "Aucun mot de passe : un lien reçu par courriel, valable quinze minutes.": {
    "de": "Kein Passwort: ein E-Mail-Link, fünfzehn Minuten gültig.",
    "en": "No password: an emailed link valid for fifteen minutes."
  },
  "Le même parcours d’achat sur un lieu à placement libre : la « Nuit du Jazz » à la Halle des Fêtes, sans plan ni siège, « 247 places disponibles sur 250 », un choix de quantité, un tarif unique, et trois lignes « Entrée » à CHF 35.00 au panier.": {
    "de": "Derselbe Kaufablauf mit freier Platzwahl: Jazznacht in der Festhalle, ohne Plan oder Sitz, 247 von 250 Eintritten verfügbar, Mengenwahl, Einheitspreis und drei Eintritte zu CHF 35.00 im Warenkorb.",
    "en": "The same checkout for general admission: Jazz Night at the festival hall, no plan or seat, 247 of 250 entries available, quantity selection, one price and three CHF 35.00 admissions in the basket."
  },
  "Sur un lieu sans sièges numérotés, le plan disparaît entièrement : on choisit une quantité, et le billet dit « entrée ».": {
    "de": "Ohne nummerierte Plätze entfällt der Plan vollständig: Sie wählen eine Menge, das Ticket sagt Eintritt.",
    "en": "Without numbered seats, the plan disappears entirely: choose a quantity, and the ticket says admission."
  },
  "Pas de place de marché de revente.": {
    "de": "Kein Marktplatz für privaten Ticketweiterverkauf.",
    "en": "No ticket resale marketplace."
  },
  "Le public réserve et les montants ne transitent jamais par nous. Le paiement par carte via Stripe peut être activé avec le compte propre à votre théâtre. Payrexx est également préparé. Un seul prestataire en ligne peut être actif par théâtre, en complément de la facture. Sans prestataire configuré et testé, le paiement en ligne n’est pas proposé. Les frais du prestataire relèvent de votre contrat ; la facture et les communications restent produites par RidoMio.": {
    "de": "Gäste buchen bei Ihnen; die Beträge fliessen nie über uns. Stripe kann mit dem eigenen Konto Ihres Hauses aktiviert werden. Payrexx ist ebenfalls vorbereitet. Pro Haus kann neben Rechnungen ein Online-Zahlungsanbieter aktiv sein. Ohne geprüfte Konfiguration wird keine Online-Zahlung angeboten. Anbietergebühren richten sich nach Ihrem Vertrag; Rechnungen und Mitteilungen erstellt RidoMio.",
    "en": "Guests book with you and funds never pass through us. Stripe can be enabled with your venue’s own account. Payrexx is also prepared. One online provider can be active per venue alongside invoices. Online payment is unavailable without tested configuration. Provider fees follow your contract; RidoMio still produces invoices and communications."
  },
  "Nous outillons votre salle sans fournir de public ni organiser une revente entre particuliers. Les partenaires disposent de contingents et relevés dédiés. Les segments de communication et le connecteur CRM restent soumis au consentement et à une configuration vérifiée ; aucune campagne ne part automatiquement.": {
    "de": "Wir unterstützen Ihren Veranstaltungsort, bringen aber kein Publikum und organisieren keinen privaten Ticketweiterverkauf. Partner erhalten eigene Kontingente und Abrechnungen. Kommunikationssegmente und CRM-Anbindung erfordern Einwilligung und geprüfte Einrichtung; Kampagnen werden nicht automatisch versandt.",
    "en": "We equip your venue without supplying an audience or organising private ticket resale. Partners have dedicated allocations and statements. Communication segments and the CRM connector require consent and verified setup; campaigns are never sent automatically."
  },
  "Aucun rapprochement bancaire automatique sans validation humaine : importez un camt.054 ou un CSV, vérifiez les propositions puis confirmez. La caisse conserve les montants réellement reçus et les comptages. Aucune relance automatique : vous choisissez les destinataires et déclenchez l’envoi. Les reports, avoirs et remboursements suivent une politique du lieu et une décision humaine ; un remboursement en ligne reste à rapprocher avec la confirmation du prestataire.": {
    "de": "Kein Bankabgleich ohne menschliche Bestätigung: Importieren Sie camt.054 oder CSV, prüfen und bestätigen Sie die Vorschläge. Die Kasse bewahrt tatsächlich erhaltene Beträge und Zählungen auf. Keine automatischen Mahnungen: Sie wählen Empfänger und lösen den Versand aus. Umbuchungen, Gutschriften und Erstattungen folgen den Regeln des Hauses und einer menschlichen Entscheidung; Online-Erstattungen müssen mit der Anbieterbestätigung abgeglichen werden.",
    "en": "Bank reconciliation requires human approval: import camt.054 or CSV, review proposals and confirm. The till records actual receipts and counts. No automatic reminders: you select recipients and start delivery. Exchanges, credit notes and refunds follow venue policy and a human decision; online refunds still require reconciliation with provider confirmation."
  },
  "Stripe ou Payrexx se configure par organisme depuis la console superadmin. Un seul est actif à la fois, avec des tests préalables. Le prestataire traite uniquement le paiement ; RidoMio conserve la facture et les communications. Les contrats et les montants restent les vôtres.": {
    "de": "Stripe oder Payrexx wird pro Organisation in der Superadmin-Konsole eingerichtet. Nach vorherigen Tests ist jeweils nur einer aktiv. Der Anbieter verarbeitet nur die Zahlung; RidoMio erstellt Rechnung und Mitteilungen. Verträge und Beträge bleiben bei Ihnen.",
    "en": "Stripe or Payrexx is configured per organisation in the superadmin console. Only one is active at a time, after testing. The provider only processes payment; RidoMio retains invoicing and communications. Contracts and funds remain yours."
  },
  "Groupes avec devis et option datée, liste d’attente confirmée, accueil PMR et accompagnant, dossiers de correction et de report.": {
    "de": "Gruppen mit Angebot und befristeter Option, bestätigte Warteliste, barrierefreier Empfang mit Begleitperson sowie Korrektur- und Umbuchungsfälle.",
    "en": "Groups with quotes and dated options, confirmed waiting lists, accessible admission with companions, and tracked correction or exchange requests."
  },
  "Bons et promotions, impressions A4/A6 ou thermiques, Wallet après configuration et essai ; transfert accepté par le destinataire avec révocation du QR initial.": {
    "de": "Gutscheine und Aktionen, A4/A6- oder Thermodruck, Wallet nach Einrichtung und Test; von der empfangenden Person angenommene Übertragung mit Widerruf des alten QR-Codes.",
    "en": "Vouchers and promotions, A4/A6 or thermal printing, Wallet after setup and testing; recipient-approved transfers revoke the original QR."
  },
  "Partenaires avec contingents et relevés, pilotage des recettes et des flux, segments consentants et connecteurs CRM/SMS activés après recette.": {
    "de": "Partner mit Kontingenten und Abrechnungen, Auswertung von Umsatz und Geldflüssen, einwilligungsbasierte Segmente und CRM/SMS-Anbindungen nach Abnahme.",
    "en": "Partners with allocations and statements, sales and cash-flow reporting, consent-based segments and CRM/SMS connectors activated after acceptance testing."
  }
}
